import './style.css';
import './timeline.css';
import './triage.css';
import './historialAnalysis.css';
import { AuthService } from './authService.js';
import { CaseService } from './caseService.js';
import { UserService } from './userService.js';
import { CalendarService } from './calendarService.js';
import { DriveService } from './driveService.js';
import { DocsService } from './docsService.js';
import { FinancialService } from './financialService.js';
import { ContactService } from './contactService.js';
import { TimelineService } from './timelineService.js';
import { calculateCriticalDeadlines, calculateUrgencyLevel, generateRiskAnalysis, addBusinessDays } from './legalDeadlines.js';
import { analyzeDocument, analyzeBatchDocuments, getAnalysisStats, getTimelineTypeFromDocType, getColorFromDocType } from './documentAnalyzer.js';
import { processBatchWithTriage, generateTriageReport, getTriageIcon, getActionLabel } from './documentTriage.js';
import { initHistorialSystem, analyzeDocumentsInHistorial, runDeepAIAnalysis } from './historialAnalyzer.js';
import { analyzeScannedImageWithGemini, generateCaseSummaryWithGemini, geminiAnalysisToTimelineEvent } from './geminiAnalyzer.js';
import { extractDateFromFilename } from './documentAnalyzer.js';
import { DemandUI } from './demandUI.js';
import { AdminUI } from './adminUI.js';
import './triage.css';



const app = document.querySelector('#app');
const APP_VERSION = 'v3.4.0-UNLIMITED';

const state = {
  user: null,
  fbUser: null,
  googleToken: null,
  currentView: 'loading',
  currentCase: null,
  currentCaseId: null,
  params: {}
};
window.state = state; // Global access for modules

const LEGAL_LIBRARIES = {
  'MASTER': { name: 'Bóveda Maestra', url: 'https://notebooklm.google.com/' },
  'CIVIL': { name: 'Biblioteca Civil', url: 'https://notebooklm.google.com/' },
  'FAMILIA': { name: 'Biblioteca Familia', url: 'https://notebooklm.google.com/' },
  'PENAL': { name: 'Biblioteca Penal', url: 'https://notebooklm.google.com/' },
  'LABORAL': { name: 'Biblioteca Laboral', url: 'https://notebooklm.google.com/' },
  'ADMINISTRATIVO': { name: 'Biblioteca Admin', url: 'https://notebooklm.google.com/' }
};

const DOCUMENT_TEMPLATES = {
  'CIVIL': [
    { id: 'temp_civil_1', name: 'Demanda Ordinaria Cobro' },
    { id: 'temp_civil_2', name: 'Contestación Negativa' }
  ],
  'FAMILIA': [
    { id: 'temp_fam_1', name: 'Solicitud Divorcio Mutuo' },
    { id: 'temp_fam_2', name: 'Incidente Rebaja Pensión' }
  ],
  'PENAL': [
    { id: 'temp_penal_1', name: 'Querella Privada' },
    { id: 'temp_penal_2', name: 'Solicitud Cambio Medidas' }
  ],
  'LABORAL': [
    { id: 'temp_lab_1', name: 'Calculo Prestaciones' },
    { id: 'temp_lab_2', name: 'Carta Despido' }
  ],
  'ADMINISTRATIVO': [
    { id: 'temp_admin_1', name: 'Recurso Amparo' },
    { id: 'temp_admin_2', name: 'Reclamo Administrativo' }
  ]
};


/* --- Helper Functions --- */
function getRandomQuote() {
  const quotes = [
    { text: "La justicia es la reina de las virtudes republicanas y con ella se sostiene la igualdad y la libertad.", author: "Simón Bolívar" },
    { text: "Ganar sin combatir es lo mejor.", author: "Sun Tzu" },
    { text: "La ley es orden, y la buena ley es el buen orden.", author: "Aristóteles" }
  ];
  return quotes[Math.floor(Math.random() * quotes.length)];
}

function getLegalWarningHTML() {
  return `<div style="margin-top: 3rem; text-align: center; border-top: 1px solid var(--glass-border); padding-top: 1rem;">
        <p style="font-size: 0.7rem; color: var(--text-muted);">
            ⚠️ CONFIDENCIALIDAD: La información contenida en este sistema está protegida por secreto profesional.
        </p>
    </div>`;
}

function getSidebarHTML(activeView) {
  const menuItems = [
    { id: 'dashboard', icon: '🏠', label: 'Inicio', action: "state.currentView='dashboard'; renderApp();" },
    { id: 'cases-list', icon: '📂', label: 'Expedientes', action: "state.currentView='cases-list'; renderApp();" },
    { id: 'agenda', icon: '📅', label: 'Agenda', action: "state.currentView='agenda'; renderApp();" },
    { id: 'calendar', icon: '📆', label: 'Calendario', action: "state.currentView='calendar'; renderApp();" },
    { id: 'marketing', icon: '📣', label: 'Marketing', action: "state.currentView='marketing'; renderApp();" },
  ];

  return `
    <aside style="background: rgba(15, 23, 42, 0.6); backdrop-filter: blur(20px); border-right: 1px solid var(--glass-border); padding: 2rem; display: flex; flex-direction: column; justify-content: space-between;">
        <div>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 3rem; padding-bottom: 1rem; border-bottom: 1px solid var(--glass-border);">
                <div style="width: 40px; height: 40px; background: var(--primary-gold); border-radius: 8px; display: flex; align-items: center; justify-content: center;">
                    <span style="color: black; font-weight: 800; font-size: 1.2rem;">L</span>
                </div>
                <div>
                    <h2 style="font-size: 1.1rem; font-weight: 800; letter-spacing: 1px;">LEXO CONTROL</h2>
                    <p style="font-size: 0.6rem; color: var(--primary-gold);">ELITE LEGAL SYSTEM</p>
                </div>
            </div>
            <nav style="display: flex; flex-direction: column; gap: 1rem;">
                ${menuItems.map(item => `
                    <button onclick="${item.action}" class="${activeView === item.id ? 'active-menu' : ''}" style="display: flex; align-items: center; gap: 15px; padding: 1rem; width: 100%; text-align: left; background: ${activeView === item.id ? 'rgba(197, 160, 89, 0.1)' : 'transparent'}; border: 1px solid ${activeView === item.id ? 'rgba(197, 160, 89, 0.2)' : 'transparent'}; border-radius: 12px; color: ${activeView === item.id ? 'var(--primary-gold)' : 'var(--text-muted)'}; cursor: pointer; transition: all 0.2s; font-weight: ${activeView === item.id ? '700' : '500'};">
                        <span style="font-size: 1.2rem;">${item.icon}</span>
                        ${item.label}
                    </button>
                `).join('')}
            </nav>
        </div>
        <div style="border-top: 1px solid var(--glass-border); padding-top: 1.5rem;">
            <button id="logout-btn-sidebar" class="btn-outline" style="width: 100%; border-color: #ef4444; color: #ef4444; display: flex; align-items: center; justify-content: center; gap: 10px;">
                <span>🚪</span> CERRAR SESIÓN
            </button>
            <p style="text-align: center; font-size: 0.6rem; color: var(--text-muted); margin-top: 1rem;">v${APP_VERSION}</p>
        </div>
    </aside>`;
}

function renderLogin() {
  app.innerHTML = `
    <div style="min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background: radial-gradient(circle at center, #1e293b 0%, #0f172a 100%);" class="premium-gradient">
        
        <!-- Security Header -->
        <div style="margin-bottom: 2rem; display: flex; gap: 2rem; opacity: 0.6;">
            <div style="display: flex; align-items: center; gap: 8px; color: #4ade80;">
                <span>🔒</span> <span style="font-size: 0.8rem; font-weight: 600;">256-BIT SSL ENCRYPTION</span>
            </div>
            <div style="display: flex; align-items: center; gap: 8px; color: #60a5fa;">
                <span>🛡️</span> <span style="font-size: 0.8rem; font-weight: 600;">VERIFIED LEGAL FIRM</span>
            </div>
        </div>

        <div class="glass-container" style="padding: 4rem; width: 100%; max-width: 500px; text-align: center; border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);">
            
            <div style="width: 80px; height: 80px; background: linear-gradient(135deg, var(--primary-gold), #b45309); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 2rem auto; box-shadow: 0 10px 15px -3px rgba(197, 160, 89, 0.3);">
                <span style="color: white; font-weight: 800; font-size: 2.5rem; font-family: 'Playfair Display', serif;">L</span>
            </div>
            
            <h1 style="font-family: var(--font-title); font-size: 2.5rem; margin-bottom: 0.5rem; color: white; letter-spacing: -1px;">CONTROL LEGAL TOTAL</h1>
            <p style="color: var(--primary-gold); margin-bottom: 3rem; font-size: 0.9rem; letter-spacing: 2px; text-transform: uppercase; font-weight: 700;">Sistema de Gestión Jurídica Elite</p>
            
            <button id="btn-login-google" style="width: 100%; padding: 1.2rem; background: white; color: #0f172a; border: none; border-radius: 12px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 12px; margin-bottom: 2rem; font-size: 1.1rem; transition: transform 0.2s; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);">
                <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" width="24">
                <span>Acceder con Credenciales</span>
            </button>

            <div style="border-top: 1px solid rgba(255,255,255,0.1); padding-top: 1.5rem; margin-top: 1.5rem;">
                <p style="font-size: 0.7rem; color: #94a3b8; line-height: 1.5;">
                    <strong>ADVERTENCIA LEGAL:</strong> Este sistema contiene información confidencial protegida por el secreto profesional abogado-cliente. El acceso no autorizado es un delito federal penalizado por la ley.
                </p>
            </div>
        </div>

        <!-- Footer Badges -->
        <div style="margin-top: 3rem; display: flex; gap: 20px; filter: grayscale(1); opacity: 0.4;">
            <img src="https://upload.wikimedia.org/wikipedia/commons/e/e4/Google_Earth_icon.svg" height="30" title="Hosted on Google Cloud">
            <img src="https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg" height="30" title="Secure Codebase">
        </div>
    </div>`;

  document.getElementById('btn-login-google').addEventListener('click', async () => {
    try {
      await AuthService.loginWithGoogle();
    } catch (error) {
      alert("Error al iniciar sesión: " + error.message);
    }
  });
}

function forceSystemUpdate() {
  window.location.reload(true);
}

function getYouTubeId(url) {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
}

async function renderApp() {
  console.log("RenderApp State:", state.currentView, state.user);
  if (state.currentView === 'loading') {
    app.innerHTML = '<div class="loading-state"><div class="spinner"></div><p>Cargando Sistema...</p></div>';
    return;
  }
  if (!state.user && state.currentView !== 'login') {
    state.currentView = 'login';
  }
  if (state.currentView === 'login') {
    renderLogin();
    return;
  }

  switch (state.currentView) {
    case 'dashboard': renderDashboard(); break;
    case 'cases-list':
      if (typeof renderCasesDashboard !== 'undefined') await renderCasesDashboard();
      else loadCases();
      break;
    case 'case-detail': renderCaseDetail(); break;
    case 'calendar': await renderCalendar(); break;
    case 'agenda': await renderAgendaView(); break;
    case 'marketing': renderMarketingDashboard(); break;
    default: renderDashboard();
  }
}


async function renderDashboard() {
  const quote = getRandomQuote();
  app.innerHTML = `
        <div style="min-height: 100vh; padding: 2rem;" class="premium-gradient">
            <header style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 3rem; max-width: 1400px; margin-left: auto; margin-right: auto; flex-wrap: wrap; gap: 1rem;">
                <div>
                   <h1 style="font-family: var(--font-title); font-size: 2.2rem; margin-bottom: 0.2rem;" class="gold-text">CONTROL LEGAL TOTAL</h1>
                   <p style="color: var(--text-muted); font-size: 0.9rem; letter-spacing: 1px;">SISTEMA DE GESTIÓN JURÍDICA ELITE v${APP_VERSION}</p>
                </div>
                
                <div style="display: flex; align-items: center; gap: 1.5rem;">
                    <!-- Communication Buttons (Header) -->
                    <div style="display: flex; gap: 15px; padding-right: 1.5rem; border-right: 1px solid var(--glass-border);">
                         <button id="btn-whatsapp" title="WhatsApp" style="background:none; border:none; font-size: 1.4rem; cursor: pointer; transition: transform 0.2s;">💬</button>
                         <button id="btn-telegram" title="Telegram" style="background:none; border:none; font-size: 1.4rem; cursor: pointer; transition: transform 0.2s;">✈️</button>
                         <button id="btn-signal" title="Signal" style="background:none; border:none; font-size: 1.4rem; cursor: pointer; transition: transform 0.2s;">🔒</button>
                    </div>

                    <div style="display: flex; align-items: center; gap: 1rem;">
                        <img src="${state.user.photoURL || 'https://ui-avatars.com/api/?name=' + state.user.displayName}" style="width: 45px; height: 45px; border-radius: 50%; border: 2px solid var(--primary-gold); object-fit: cover;">
                        <div style="text-align: right;">
                            <p style="font-weight: 700; color: white;">${state.user.displayName}</p>
                            <p style="font-size: 0.7rem; color: var(--primary-gold);">${state.user.role?.replace('_', ' ').toUpperCase()}</p>
                        </div>
                    </div>
                     <button id="btn-logout-header" class="btn-outline" style="font-size: 0.7rem; padding: 0.5rem 1rem; border-color: rgba(239, 68, 68, 0.4); color: #ef4444;">SALIR</button>
                </div>
            </header>

            <main style="max-width: 1400px; margin: 0 auto;">
                <!-- Quote Section -->
                <div style="margin-bottom: 3rem; text-align: center; max-width: 800px; margin-left: auto; margin-right: auto;">
                    <p style="font-style: italic; color: #e2e8f0; font-size: 1.1rem;">"${quote.text}"</p>
                    <span style="font-size: 0.8rem; color: var(--primary-gold); font-weight: 700; text-transform: uppercase;">— ${quote.author}</span>
                </div>

                <!-- Unified Modules Grid -->
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 2rem; margin-bottom: 2rem;">
                    
                    <!-- 1. GESTION DE EXPEDIENTES -->
                    <div id="card-expedientes" onclick="state.currentView='cases-list'; renderApp();" style="background: linear-gradient(145deg, rgba(16, 185, 129, 0.1), rgba(6, 78, 59, 0.05)); border: 1px solid rgba(16, 185, 129, 0.3); border-radius: 16px; padding: 2.5rem; cursor: pointer; transition: all 0.3s; text-align: center;">
                        <div style="width: 70px; height: 70px; background: rgba(16, 185, 129, 0.2); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 1.5rem auto;">
                            <span style="font-size: 2.5rem;">📂</span>
                        </div>
                        <h3 style="font-size: 1.5rem; margin-bottom: 0.5rem; color: #34d399; font-weight: 800;">EXPEDIENTES</h3>
                        <p style="font-size: 0.9rem; color: #94a3b8;">Base de Datos de Casos</p>
                    </div>

                    <!-- 2. AGENDA -->
                    <div id="card-agenda" onclick="state.currentView='agenda'; renderApp();" style="background: linear-gradient(145deg, rgba(37, 99, 235, 0.1), rgba(30, 64, 175, 0.05)); border: 1px solid rgba(59, 130, 246, 0.3); border-radius: 16px; padding: 2.5rem; cursor: pointer; transition: all 0.3s; text-align: center;">
                        <div style="width: 70px; height: 70px; background: rgba(59, 130, 246, 0.2); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 1.5rem auto;">
                            <span style="font-size: 2.5rem;">📅</span>
                        </div>
                        <h3 style="font-size: 1.5rem; margin-bottom: 0.5rem; color: #60a5fa; font-weight: 800;">AGENDA & PLAZOS</h3>
                        <p style="font-size: 0.9rem; color: #94a3b8;">Control de Audiencias</p>
                    </div>

                    <!-- 3. INTELIGENCIA -->
                    <div id="card-intelligence" onclick="window.open('${LEGAL_LIBRARIES['MASTER']?.url}', '_blank')" style="background: linear-gradient(145deg, rgba(124, 58, 237, 0.1), rgba(76, 29, 149, 0.05)); border: 1px solid rgba(167, 139, 250, 0.3); border-radius: 16px; padding: 2.5rem; cursor: pointer; transition: all 0.3s; text-align: center;">
                        <div style="width: 70px; height: 70px; background: rgba(167, 139, 250, 0.2); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 1.5rem auto;">
                            <span style="font-size: 2.5rem;">🧠</span>
                        </div>
                        <h3 style="font-size: 1.5rem; margin-bottom: 0.5rem; color: #a78bfa; font-weight: 800;">INTELIGENCIA</h3>
                        <p style="font-size: 0.9rem; color: #94a3b8;">Bóveda Doctrinaria</p>
                    </div>

                </div>

                <!-- SECONDARY MODULES AREA -->
                <div style="margin-top: 4rem; text-align: center; border-top: 1px solid var(--glass-border); padding-top: 2rem;">
                    <p style="color: var(--text-muted); font-size: 0.8rem; letter-spacing: 2px; text-transform: uppercase; margin-bottom: 2rem;">HERRAMIENTAS AUXILIARES</p>
                    
                    <div style="display: flex; gap: 2rem; justify-content: center; flex-wrap: wrap;">
                         <!-- MARKETING -->
                        <div id="card-marketing" onclick="state.currentView='marketing'; renderApp();" style="background: rgba(220, 38, 38, 0.05); border: 1px dashed rgba(248, 113, 113, 0.3); border-radius: 12px; padding: 1.5rem 2.5rem; cursor: pointer; transition: all 0.3s; text-align: center; display: flex; align-items: center; gap: 15px;">
                            <span style="font-size: 1.5rem;">📣</span>
                            <div>
                                <h3 style="font-size: 0.9rem; color: #f87171; font-weight: 800; margin: 0;">MARKETING</h3>
                            </div>
                        </div>

                        <!-- FINANZAS (Placeholder per user request) -->
                        <div id="card-finanzas" onclick="alert('Módulo en Desarrollo')" style="background: rgba(16, 185, 129, 0.05); border: 1px dashed rgba(52, 211, 153, 0.3); border-radius: 12px; padding: 1.5rem 2.5rem; cursor: pointer; transition: all 0.3s; text-align: center; display: flex; align-items: center; gap: 15px;">
                            <span style="font-size: 1.5rem;">💰</span>
                            <div>
                                <h3 style="font-size: 0.9rem; color: #34d399; font-weight: 800; margin: 0;">FINANZAS</h3>
                            </div>
                        </div>
                    </div>
                </div>

                ${getLegalWarningHTML()}
            </main>
        </div>
    `;

  // Communication & Header buttons
  document.getElementById('btn-logout-header').addEventListener('click', () => AuthService.logout());
  document.getElementById('btn-whatsapp').addEventListener('click', () => window.open('https://web.whatsapp.com', '_blank'));
  document.getElementById('btn-telegram').addEventListener('click', () => window.open('https://web.telegram.org/a/', '_blank'));
  document.getElementById('btn-signal').addEventListener('click', () => window.open('https://signal.org/download/', '_blank'));
}

async function renderCasesDashboard() {
  console.log("Renderizando dashboard de expedientes...");
  app.innerHTML = `
    <div style="display: grid; grid-template-columns: 280px 1fr; height: 100vh;" class="premium-gradient">
      ${getSidebarHTML('cases-list')}

  <main style="padding: 3rem; overflow-y: auto;">
    <header style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 3rem;" class="fade-in">
      <div>
        <h1 style="font-family: var(--font-title); font-size: 2.5rem; margin-bottom: 0.5rem;" class="gold-text">Gestión de Expedientes</h1>
        <p style="color: var(--text-muted); font-size: 1.1rem;">Consulte y administre todos sus procesos judiciales activos y compartidos.</p>
      </div>
      <div>
        <button onclick="showNewCaseModal()" style="padding: 1rem 2rem; background: var(--primary-gold); color: #0a0f1e; border: none; border-radius: 12px; font-weight: 800; cursor: pointer; display: flex; align-items: center; gap: 10px; box-shadow: 0 10px 20px rgba(197, 160, 89, 0.2); transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
          <span style="font-size: 1.2rem;">+</span> NUEVO EXPEDIENTE
        </button>
      </div>
    </header>

    <div style="background: rgba(30, 41, 59, 0.5); border: 1px solid var(--glass-border); padding: 1.5rem; border-radius: 16px; display: flex; gap: 1rem; margin-bottom: 2rem;" class="fade-in">
      <div style="flex: 1; position: relative;">
        <span style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); font-size: 1.2rem;">🔍</span>
        <input type="text" id="case-search-input" onkeyup="filterCases()" placeholder="Buscar por cliente, ID judicial, materia o contraparte..." style="width: 100%; padding: 1rem 1rem 1rem 3.5rem; border-radius: 10px; border: 1px solid var(--glass-border); background: rgba(0,0,0,0.3); color: white; outline: none; font-size: 1rem;">
      </div>
      <select id="case-filter-type" onchange="filterCases()" style="padding: 0 2rem; border-radius: 10px; border: 1px solid var(--glass-border); background: rgba(15, 23, 42, 0.8); color: white; outline: none; cursor: pointer;">
        <option value="all">Todas las Materias</option>
        <option value="CIVIL">Civil</option>
        <option value="FAMILIA">Familia</option>
        <option value="PENAL">Penal</option>
        <option value="LABORAL">Laboral</option>
        <option value="ADMINISTRATIVO">Administrativo</option>
      </select>
    </div>

    <div id="cases-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); gap: 2rem;" class="fade-in">
      <p style="color: var(--text-muted);">Cargando expedientes...</p>
    </div>
  </main>
        </div>
    `;

  loadCases();
}

let allCasesCache = [];

async function loadCases() {
  console.log("Cargando casos...");
  const grid = document.querySelector('#cases-grid');
  grid.innerHTML = '<p style="color: var(--text-muted);">Sincronizando expedientes...</p>';

  try {
    const cases = await CaseService.getMyCases(state.user.uid, state.user.role || 'abogado_titular');
    allCasesCache = cases; // Cache for filtering
    renderCasesList(cases);
  } catch (err) {
    grid.innerHTML = `<p style="color: #ef4444;">Error al cargar datos. Verifique permisos.</p>`;
  }
}

window.filterCases = () => {
  const term = document.querySelector('#case-search-input').value.toLowerCase();
  const typeFilter = document.querySelector('#case-filter-type')?.value || 'all';

  const filtered = allCasesCache.filter(c => {
    const matchesTerm = Object.values(c).map(val => String(val).toLowerCase()).join(' ').includes(term);
    const matchesType = typeFilter === 'all' || c.type === typeFilter;
    return matchesTerm && matchesType;
  });
  renderCasesList(filtered);
}

function renderCasesList(cases) {
  const grid = document.querySelector('#cases-grid');

  if (cases.length === 0) {
    grid.innerHTML = `
    <div style="grid-column: 1/-1; padding: 4rem; text-align: center; border: 1px dashed var(--glass-border); border-radius: 20px;">
      <p style="color: var(--text-muted); font-size: 1.2rem;">No se encontraron expedientes coincidientes.</p>
                ${allCasesCache.length === 0 ? '<button onclick="showNewCaseModal()" style="margin-top: 1rem; padding: 0.8rem 1.5rem; border: 1px solid var(--primary-gold); color: var(--primary-gold); background: transparent; border-radius: 8px; font-weight: 700; cursor: pointer;">Crear Primer Expediente</button>' : ''}
            </div>`;
    return;
  }

  grid.innerHTML = cases.map(c => `
    <div class="glass-container case-card fade-in" style="padding: 2.5rem; border-top: 2px solid var(--primary-gold); position: relative; overflow: hidden; transition: transform 0.3s;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
            <div style="position: absolute; top: -10px; right: -10px; width: 60px; height: 60px; background: var(--primary-gold); opacity: 0.05; border-radius: 50%;"></div>
            
            <div style="display: flex; justify-content: space-between; margin-bottom: 2rem; align-items: center;">
                <span style="background: rgba(197, 160, 89, 0.1); color: var(--primary-gold); padding: 0.4rem 1rem; border-radius: 50px; font-size: 0.65rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; border: 1px solid rgba(197, 160, 89, 0.2);">${c.type || 'CIVIL'}</span>
                <span style="color: var(--text-muted); font-size: 0.75rem; font-family: 'Outfit'; font-weight: 600; letter-spacing: 0.5px;">${c.judicialId || 'S/N'}</span>
            </div>
            
            <h3 style="font-family: var(--font-title); font-size: 1.5rem; margin-bottom: 1rem; line-height: 1.1; color: white;">${c.title}</h3>
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 2.5rem;">
                <div style="width: 8px; height: 8px; background: #4ade80; border-radius: 50%; box-shadow: 0 0 10px #4ade80;"></div>
                <span style="font-size: 0.8rem; color: #4ade80; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">Activo</span>
            </div>
            
            <div style="display: flex; gap: 15px;">
                <button class="btn-open-case btn-outline" data-id="${c.id}" style="flex: 1; padding: 0.9rem; font-weight: 700; font-size: 0.85rem;">
                    ABRIR EXPEDIENTE
                </button>
                ${c.notebookLMUrl ? `
                    <button onclick="window.open('${c.notebookLMUrl}', '_blank')" style="padding: 0 1.2rem; border-radius: 12px; background: rgba(59, 130, 246, 0.1); border: 1px solid rgba(59, 130, 246, 0.2); color: #60a5fa; cursor: pointer; display: flex; align-items: center; justify-content: center;">
                        🚀
                    </button>
                ` : ''}
            </div>
        </div>
    `).join('');

  document.querySelectorAll('.btn-open-case').forEach(btn => {
    btn.addEventListener('click', () => openCase(btn.dataset.id));
  });
}

async function openCase(id) {
  state.currentView = 'loading';
  renderApp();
  try {
    state.currentCase = await CaseService.getCaseById(id);
    state.currentCaseId = id;
    state.currentView = 'case-detail';
    renderApp();
  } catch (err) {
    alert('No tiene autorización para ver este expediente.');
    state.currentView = 'dashboard';
    renderApp();
  }
}

function renderCaseDetail() {
  const c = state.currentCase;
  app.innerHTML = `
    <div style="display: grid; grid-template-columns: 280px 1fr; height: 100vh;" class="premium-gradient">
      ${getSidebarHTML('dashboard')}
            <!--Main Content Detalle-->
    <main style="padding: 3rem; overflow-y: auto;">
      <header style="margin-bottom: 3.5rem;" class="fade-in">
        <div style="display: flex; align-items: center; gap: 15px; margin-bottom: 1.5rem;">
          <button onclick="state.currentView='dashboard'; renderApp();" class="btn-outline" style="padding: 0.5rem 1.2rem; font-size: 0.8rem; border-radius: 50px;">← VOLVER</button>
          <span style="background: rgba(197, 160, 89, 0.1); color: var(--primary-gold); padding: 0.4rem 1.2rem; border-radius: 50px; font-size: 0.7rem; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; border: 1px solid rgba(197, 160, 89, 0.2);">${c.type}</span>
          ${c.notebookLMUrl ? `
                        <button onclick="window.open('${c.notebookLMUrl}', '_blank')" style="display: flex; align-items: center; gap: 8px; background: rgba(59, 130, 246, 0.15); border: 1px solid rgba(59, 130, 246, 0.4); color: #60a5fa; padding: 0.5rem 1rem; border-radius: 50px; font-size: 0.75rem; font-weight: 700; cursor: pointer; transition: all 0.2s;">
                           <span>🧠</span> CONSULTAR A NOTEBOOK LM
                        </button>
                        ` : ''}
        </div>
        <h1 style="font-family: var(--font-title); font-size: 3rem; margin-bottom: 0.5rem; line-height: 1.1;" class="gold-text">${c.title}</h1>
        <p style="color: var(--text-muted); font-size: 1.2rem; font-weight: 500;">ID Judicial: <span style="color: white; font-family: 'Outfit';">${c.judicialId || 'Sin asignar'}</span></p>
      </header>

      <div style="display: flex; gap: 2.5rem; margin-bottom: 2.5rem; border-bottom: 1px solid var(--glass-border);" class="fade-in">
        <button id="tab-history" class="active-tab tab-btn">📝 Historial Procesal</button>
        <button id="tab-folios" class="tab-btn">📂 Índice de Folios</button>
        <button id="tab-timeline" class="tab-btn">📊 Timeline</button>
        <button id="tab-draftings" class="tab-btn">✍️ Redacción</button>
        <button id="tab-finance" class="tab-btn">💰 Finanzas</button>
      </div>

      <div style="display: grid; grid-template-columns: 2fr 1fr; gap: 3rem;" class="fade-in">
        <!-- Columna Izquierda: Contenido Variable -->
        <section id="case-content-area">
          <!-- Vista: Historial -->
          <div id="view-history" class="glass-container" style="padding: 2.5rem;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2.5rem;">
              <h2 style="font-size: 1.3rem; display: flex; align-items: center; gap: 12px;" class="gold-text"><span>📝</span> Documentación Caso ${c.title}</h2>
              <div style="display: flex; gap: 10px;">
                <button id="btn-prepare-demand" class="btn-outline" style="padding: 0.6rem 1.2rem; font-size: 0.8rem; border-color: var(--primary-gold); color: var(--primary-gold); font-weight: 700;">⚖️ PREPARAR DEMANDA</button>
                <button id="btn-analyze-docs" class="analyze-ai-btn">🤖 Analizar con IA</button>
                <button id="btn-new-action" class="btn-gold" style="padding: 0.6rem 1.2rem; font-size: 0.8rem;">+ NUEVA NOTA</button>
              </div>
            </div>
            <div id="actions-list" style="border-left: 2px solid var(--glass-border); padding-left: 25px; margin-left: 10px; display: flex; flex-direction: column; gap: 2.5rem;">
              <p style="color: var(--text-muted); font-style: italic;">Cargando historial estratégico...</p>
            </div>
          </div>

          <!-- Vista: Índice de Folios (Oculto inicialmente) -->
          <div id="view-folios" class="glass-container" style="padding: 2.5rem; display: none;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2.5rem;">
              <h2 style="font-size: 1.3rem; display: flex; align-items: center; gap: 12px;" class="gold-text"><span>📂</span> Índice de Folios Digitales</h2>
              <button onclick="window.open('${c.driveFolderLink}', '_blank')" class="btn-outline" style="padding: 0.6rem 1.2rem; font-size: 0.8rem;">ABRIR EN DRIVE</button>
            </div>
            <div id="folios-list" style="display: flex; flex-direction: column; gap: 1.2rem;">
              <p style="color: var(--text-muted); font-style: italic;">Sincronizando archivos...</p>
            </div>
          </div>

          </div>

          <!-- Vista: Redacción (Oculto inicialmente) -->
          <div id="view-draftings" class="glass-container" style="padding: 2.5rem; display: none;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2.5rem;">
               <h2 style="font-size: 1.3rem; display: flex; align-items: center; gap: 12px;" class="gold-text"><span>✍️</span> Redacción & Trámites</h2>
               <button onclick="showNewWritingModal('${c.id}')" class="btn-gold" style="padding: 0.6rem 1.2rem; font-size: 0.8rem;">+ NUEVO ESCRITO</button>
            </div>
             <div id="draftings-list" style="display: flex; flex-direction: column; gap: 1.5rem;">
                <!-- List content will be loaded here -->
             </div>
          </div>

          <!-- Vista: Timeline (Oculto inicialmente) -->
          <div id="view-timeline" class="glass-container" style="padding: 2.5rem; display: none;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2.5rem;">
              <h2 style="font-size: 1.3rem; display: flex; align-items: center; gap: 12px;" class="gold-text">
                <span>📊</span> Chronos Timeline
              </h2>
              <div style="display: flex; gap: 10px;">
                <button onclick="syncTimelineFromActions('${c.id}')" class="btn-outline" style="padding: 0.6rem 1.2rem; font-size: 0.8rem;">
                  🔄 SINCRONIZAR
                </button>
                <button onclick="showNewEventModal('${c.id}')" class="btn-gold" style="padding: 0.6rem 1.2rem; font-size: 0.8rem;">
                  + NUEVO EVENTO
                </button>
              </div>
            </div>
            
             <div id="timeline-risk-alerts"></div>

            <!-- Timeline Container -->
            <div id="timeline-container" class="timeline-container">
              <!-- Controles de Zoom -->
              <div class="timeline-controls">
                <button class="timeline-control-btn" onclick="zoomTimeline('in')" title="Acercar">+</button>
                <button class="timeline-control-btn" onclick="zoomTimeline('out')" title="Alejar">−</button>
                <button class="timeline-control-btn" onclick="zoomTimeline('fit')" title="Ajustar">⊡</button>
              </div>
              
              <!-- Leyenda -->
              <div class="timeline-legend">
                <div class="legend-item">
                  <span class="legend-dot" style="--legend-color: #c5a059;"></span>
                  <span>Hecho Generador</span>
                </div>
                <div class="legend-item">
                  <span class="legend-dot" style="--legend-color: #ef4444;"></span>
                  <span>Demanda</span>
                </div>
                <div class="legend-item">
                  <span class="legend-dot" style="--legend-color: #facc15;"></span>
                  <span>Sentencia</span>
                </div>
                <div class="legend-item">
                  <span class="legend-dot" style="--legend-color: #10b981;"></span>
                  <span>Prueba</span>
                </div>
                <div class="legend-item">
                  <span class="legend-dot" style="--legend-color: #3b82f6;"></span>
                  <span>Notificación</span>
                </div>
              </div>
              
              <!-- Track de Timeline -->
              <div class="timeline-track" id="timeline-track"></div>
              
              <!-- Marcador de Presente -->
              <div class="timeline-present-marker" id="present-marker">
                <div class="present-marker-dot"></div>
                <div class="present-marker-label">HOY</div>
              </div>
              
              <!-- Eventos se renderizarán aquí dinámicamente -->
              <div id="timeline-events"></div>
            </div>
            
            <!-- Panel de Detalles (se muestra al hacer click en evento) -->
            <div id="event-details-panel" style="display: none;"></div>
          </div>

          <!-- Vista: Finanzas (Oculto inicialmente) -->
          <div id="view-finance" class="glass-container" style="padding: 2.5rem; display: none;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2.5rem;">
              <h2 style="font-size: 1.3rem; display: flex; align-items: center; gap: 12px;" class="gold-text"><span>💰</span> Control Financiero</h2>
              <button id="btn-new-transaction" class="btn-gold" style="padding: 0.6rem 1.2rem; font-size: 0.8rem; background: #10b981;">+ REGISTRAR PAGO</button>
            </div>
            <div id="finance-summary" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; margin-bottom: 2.5rem;"></div>
            <div id="finance-list" style="display: flex; flex-direction: column; gap: 1.2rem;"></div>
          </div>
        </section>

        <!-- Columna Derecha: Información y IA -->
        <aside style="display: flex; flex-direction: column; gap: 2.5rem;">
          <div class="glass-container" style="padding: 2rem; border: 1px solid rgba(59, 130, 246, 0.2); background: rgba(59, 130, 246, 0.02);">
            <h3 style="color: #60a5fa; font-size: 0.9rem; margin-bottom: 1.5rem; display: flex; align-items: center; gap: 8px; font-weight: 800; text-transform: uppercase;">🚀 Espacios de Trabajo IA</h3>
            <div style="display: flex; flex-direction: column; gap: 1.2rem;">
              <button id="btn-extract-strategy" class="btn-outline" style="width: 100%; border-color: #10b981; color: #10b981; font-weight: 800; font-size: 0.75rem;">🛡️ EXTRAER TÁCTICA A BÓVEDA</button>
              <div style="padding: 1.2rem; background: rgba(255,255,255,0.03); border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);">
                <p style="font-size: 0.65rem; color: var(--text-muted); font-weight: 800; margin-bottom: 10px; text-transform: uppercase;">Cuaderno del Caso</p>
                ${c.notebookLMUrl ? `<button onclick="window.open('${c.notebookLMUrl}', '_blank')" class="btn-gold" style="width: 100%; font-size: 0.8rem; background: #3b82f6;">ABRIR NOTEBOOK LM</button>` : `<button disabled class="btn-outline" style="width: 100%; font-size: 0.8rem; opacity: 0.5;">SIN CUADERNO</button>`}
              </div>
            </div>
          </div>

          <div class="glass-container" style="padding: 2rem;">
            <h3 style="font-size: 0.9rem; margin-bottom: 1.5rem; font-weight: 800; text-transform: uppercase;" class="gold-text">Automatización</h3>
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              <select id="template-select" style="width: 100%; padding: 0.9rem; border-radius: 10px; border: 1px solid var(--glass-border); background: #0f172a; color: white;">
                <option value="">Seleccionar Plantilla...</option>
                ${(DOCUMENT_TEMPLATES[c.type] || []).map(t => `<option value="${t.id}">${t.name}</option>`).join('')}
              </select>
              <button id="btn-generate-doc" class="btn-gold" style="width: 100%; background: #10b981;">GENERAR ESCRITO</button>
            </div>
          </div>

          <div class="glass-container" style="padding: 2rem;">
            <h3 style="font-size: 0.9rem; margin-bottom: 1.5rem; font-weight: 800; text-transform: uppercase;">Detalles</h3>
            <div style="display: flex; flex-direction: column; gap: 1.2rem;">
              <div>
                <label style="display: block; font-size: 0.65rem; color: var(--text-muted); text-transform: uppercase; font-weight: 800; margin-bottom: 4px;">Cliente</label>
                <p style="font-size: 0.95rem; font-weight: 600;">${c.client || 'Por definir'}</p>
                ${c.clientAddress ? `<button onclick="window.open('https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(c.clientAddress)}', '_blank')" style="margin-top: 8px; font-size: 0.65rem; color: var(--primary-gold); background: none; border: none; font-weight: 800; cursor: pointer;">📍 VER UBICACIÓN</button>` : ''}
              </div>
              <div>
                <label style="display: block; font-size: 0.65rem; color: var(--text-muted); text-transform: uppercase; font-weight: 800; margin-bottom: 4px;">Fecha Registro</label>
                <p style="font-size: 0.95rem; font-weight: 600;">${new Date(c.createdAt?.seconds * 1000).toLocaleDateString()}</p>
              </div>
            </div>
          </div>
        </aside>
      </div>
      ${getLegalWarningHTML()}
    </main>
        </div >
    `;

  document.querySelector('#logout-btn-sidebar').addEventListener('click', () => AuthService.logout());
  document.querySelector('#btn-new-action').addEventListener('click', () => showNewActionModal(c.id));
  document.querySelector('#btn-analyze-docs').addEventListener('click', () => runDeepAIAnalysis(c.id));
  document.querySelector('#btn-prepare-demand').addEventListener('click', () => DemandUI.openDemandModal(c.id));
  document.querySelector('#btn-new-transaction').addEventListener('click', () => showNewTransactionModal(c.id));

  // Tabs logic
  const tabs = {
    'tab-history': 'view-history',
    'tab-folios': 'view-folios',
    'tab-timeline': 'view-timeline',
    'tab-draftings': 'view-draftings',
    'tab-finance': 'view-finance'
  };

  Object.keys(tabs).forEach(tabId => {
    document.getElementById(tabId).addEventListener('click', () => {
      Object.keys(tabs).forEach(t => {
        document.getElementById(t).classList.remove('active-tab');
        document.getElementById(tabs[t]).style.display = 'none';
      });
      document.getElementById(tabId).classList.add('active-tab');
      document.getElementById(tabs[tabId]).style.display = 'block';

      if (tabId === 'tab-folios') loadFolioIndex(c.id);
      if (tabId === 'tab-timeline') loadTimelineView(c.id);
      if (tabId === 'tab-draftings') loadDraftingView(c.id);
      if (tabId === 'tab-finance') loadFinancialView(c.id);
    });
  });

  document.querySelector('#btn-generate-doc').addEventListener('click', async () => {
    const templateId = document.querySelector('#template-select').value;
    if (!templateId) return alert('Seleccione una plantilla');
    if (!state.googleToken) return alert('Debe iniciar sesión con Google');

    const btn = document.querySelector('#btn-generate-doc');
    btn.disabled = true;
    btn.innerText = 'GENERANDO DOCUMENTO...';

    try {
      const replacements = {
        'NOMBRE_CASO': c.title,
        'ID_JUDICIAL': c.judicialId || 'S-N',
        'FECHA': new Date().toLocaleDateString(),
        'ABOGADO': state.user.displayName
      };
      const fileName = `[BORRADOR] ${c.title} - ${document.querySelector('#template-select').selectedOptions[0].text} `;
      const newDoc = await DocsService.createFromTemplate(templateId, c.driveFolderId, fileName, replacements, state.googleToken);

      await CaseService.addAction(c.id, {
        title: `Generación de documento: ${fileName} `,
        description: `Se ha generado un borrador automático basado en plantilla.\n🔗 Ver documento: ${newDoc.link} `,
        author: 'Sistema Automático'
      });

      alert('Documento generado con éxito. Se ha abierto en una nueva pestaña.');
      window.open(newDoc.link, '_blank');
      loadActions(c.id);
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      btn.disabled = false;
      btn.innerText = 'GENERAR ESCRITO';
    }
  });

  document.querySelector('#btn-extract-strategy').addEventListener('click', async () => {
    const btn = document.querySelector('#btn-extract-strategy');
    btn.disabled = true;
    btn.innerText = 'ANONIMIZANDO Y EXTRAYENDO...';

    try {
      if (!state.googleToken) throw new Error('Requiere inicio de sesión con Google');

      // ID de la plantilla de análisis estratégico (Debe ser un ID real de Google Doc en el futuro)
      const STRATEGY_TEMPLATE_ID = '1Xyyyyyy_PLACEHOLDER_ID_zzzzzz';
      // Nota: En producción, usar una plantilla real. Por ahora, crearemos un documento en blanco si falla la plantilla.

      const fileName = `[STRATEGY] Análisis Táctico - ${c.title} `;

      // Simular creación de documento (o usar createFromTemplate si tuviéramos un template real)
      // Para este MVP, crearemos un documento básico usando la API de Drive directamente si no hay template
      // Pero usaremos la estructura de DocsService asumiendo que el usuario configurará el ID

      // Por ahora, simulamos la "creación inteligente" generando un registro en el sistema
      const successMessage = `
            Se ha iniciado el proceso de extracción estratégica.
            
            1. Se ha creado el borrador: "${fileName}"
  2. Se ha notificado al equipo de Gestión del Conocimiento.
            
            (En la versión final, esto abrirá un Google Doc con el análisis pre - llenado por IA)
    `;

      await CaseService.addAction(c.id, {
        title: '🧠 Extracción de Conocimiento Estratégico',
        description: 'El caso ha sido procesado para alimentar la Bóveda Maestra del bufete. Se ha generado un análisis de táctica ganadora.',
        author: 'Legal AI Agent',
        metadata: { type: 'knowledge_extraction' }
      });

      alert(successMessage);

      btn.innerText = '🛡️ TÁCTICA EXTRAÍDA';
      btn.style.borderColor = '#4ade80';
      btn.style.color = '#4ade80';
      loadActions(c.id);

    } catch (err) {
      alert('Error: ' + err.message);
      btn.disabled = false;
      btn.innerText = '🛡️ EXTRAER TÁCTICA';
    }
  });

  loadActions(c.id);
}

async function loadFinancialView(caseId) {
  const list = document.querySelector('#finance-list');
  const summaryDiv = document.querySelector('#finance-summary');
  try {
    const trans = await FinancialService.getTransactions(caseId);
    const summary = await FinancialService.getFinancialSummary(caseId);

    summaryDiv.innerHTML = `
    <div style="background: rgba(16, 185, 129, 0.1); padding: 1rem; border-radius: 12px; border: 1px solid rgba(16, 185, 129, 0.2); text-align: center;">
            <p style="font-size: 0.6rem; color: #10b981; font-weight: 800; text-transform: uppercase;">Total Ingresos</p>
            <p style="font-size: 1.2rem; font-weight: 700;">$${summary.totalIncome.toLocaleString()}</p>
        </div>
        <div style="background: rgba(239, 68, 68, 0.1); padding: 1rem; border-radius: 12px; border: 1px solid rgba(239, 68, 68, 0.2); text-align: center;">
            <p style="font-size: 0.6rem; color: #ef4444; font-weight: 800; text-transform: uppercase;">Total Gastos</p>
            <p style="font-size: 1.2rem; font-weight: 700;">$${summary.totalExpenses.toLocaleString()}</p>
        </div>
        <div style="background: rgba(197, 160, 89, 0.1); padding: 1rem; border-radius: 12px; border: 1px solid rgba(197, 160, 89, 0.2); text-align: center;">
            <p style="font-size: 0.6rem; color: var(--secondary-color); font-weight: 800; text-transform: uppercase;">Saldo Actual</p>
            <p style="font-size: 1.2rem; font-weight: 700; color: ${summary.balance >= 0 ? '#4ade80' : '#f87171'};">$${summary.balance.toLocaleString()}</p>
        </div>
  `;

    if (trans.length === 0) {
      list.innerHTML = `<p style="color: var(--text-muted); font-style: italic;">No hay movimientos registrados.</p>`;
      return;
    }

    list.innerHTML = trans.map(t => `
    <div style="display: flex; align-items: center; gap: 15px; padding: 1rem; background: rgba(255,255,255,0.02); border: 1px solid var(--glass-border); border-radius: 12px;">
            <div style="background: ${t.type === 'income' ? '#10b981' : '#ef4444'}; width: 8px; height: 40px; border-radius: 4px;"></div>
            <div style="flex: 1;">
                <div style="display: flex; justify-content: space-between;">
                    <h5 style="font-size: 0.95rem; margin-bottom: 2px;">${t.description}</h5>
                    <p style="font-weight: 700; color: ${t.type === 'income' ? '#10b981' : '#f87171'};">${t.type === 'income' ? '+' : '-'}$${t.amount.toLocaleString()}</p>
                </div>
                <p style="font-size: 0.7rem; color: var(--text-muted); text-transform: uppercase; font-weight: 700;">
                    ${t.category} • ${new Date(t.timestamp?.seconds * 1000).toLocaleDateString()} 
                    ${t.isPaid ? '• ✅ PAGADO' : '• 🕒 PENDIENTE'}
                </p>
            </div>
        </div>
    `).join('');
  } catch (err) {
    list.innerHTML = 'Error al cargar finanzas.';
  }
}

function showNewTransactionModal(caseId) {
  const modal = document.createElement('div');
  modal.style.cssText = `position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.85); backdrop-filter: blur(12px); display: flex; align-items: center; justify-content: center; z-index: 1000;`;

  modal.innerHTML = `
    <div class="glass-container" style="width: 90%; max-width: 450px; padding: 2.5rem;">
        <h2 style="margin-bottom: 2rem;" class="gold-text">Registrar Movimiento</h2>
        <form id="new-finance-form" style="display: flex; flex-direction: column; gap: 1.2rem;">
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                <div>
                    <label style="display: block; font-size: 0.7rem; color: var(--text-muted); margin-bottom: 0.4rem;">TIPO</label>
                    <select name="type" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: #0f172a; color: white; border: 1px solid var(--glass-border);">
                        <option value="income">INGRESO (COBRO)</option>
                        <option value="expense">GASTO / COSTO</option>
                    </select>
                </div>
                <div>
                    <label style="display: block; font-size: 0.7rem; color: var(--text-muted); margin-bottom: 0.4rem;">CATEGORÍA</label>
                    <select name="category" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: #0f172a; color: white; border: 1px solid var(--glass-border);">
                        <option value="honorarios">HONORARIOS</option>
                        <option value="gastos">GASTOS GENERALES</option>
                        <option value="timbres">TIMBRES / PÓLIZAS</option>
                        <option value="comisiones">COMISIONES</option>
                        <option value="horas">HORAS PROF.</option>
                        <option value="notificaciones">NOTIFICACIONES</option>
                    </select>
                </div>
            </div>
            <div>
                <label style="display: block; font-size: 0.7rem; color: var(--text-muted); margin-bottom: 0.4rem;">DESCRIPCIÓN</label>
                <input type="text" name="description" required placeholder="Ej: Pago de timbres ley" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(255,255,255,0.03); color: white; border: 1px solid var(--glass-border);">
            </div>
            <div>
                <label style="display: block; font-size: 0.7rem; color: var(--text-muted); margin-bottom: 0.4rem;">MONTO ($)</label>
                <input type="number" name="amount" step="0.01" required placeholder="0.00" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(255,255,255,0.03); color: white; border: 1px solid var(--glass-border);">
            </div>
            <div style="display: flex; align-items: center; gap: 10px;">
                <input type="checkbox" name="isPaid" id="is-paid-check">
                <label for="is-paid-check" style="font-size: 0.8rem;">¿Ya está pagado/liquidado?</label>
            </div>
            <div style="display: flex; gap: 10px; margin-top: 1rem;">
                <button type="button" class="btn-cancel" style="flex: 1; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: transparent; color: white;">Cancelar</button>
                <button type="submit" style="flex: 1.5; background: #10b981; color: white; padding: 0.8rem; border-radius: 8px; border: none; font-weight: 800; cursor: pointer;">GUARDAR</button>
            </div>
        </form>
    </div >
    `;

  document.body.appendChild(modal);
  document.querySelector('#new-finance-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(e.target).entries());
    data.isPaid = e.target.isPaid.checked;
    data.author = state.user.displayName;

    try {
      await FinancialService.addTransaction(caseId, data);
      modal.remove();
      loadFinancialView(caseId);
    } catch (err) { alert('Error guardando transacción.'); }
  });
}

async function loadFolioIndex(caseId) {
  const list = document.querySelector('#folios-list');
  try {
    const actions = await CaseService.getActions(caseId);
    const docs = actions.filter(a => a.driveFileId).sort((a, b) => (a.folioNumber || 0) - (b.folioNumber || 0));

    if (docs.length === 0) {
      list.innerHTML = `<p style="color: var(--text-muted); font-style: italic;">No hay folios digitales registrados en este expediente.</p>`;
      return;
    }

    list.innerHTML = docs.map(d => `
    <div style="display: flex; align-items: center; gap: 15px; padding: 1rem; background: rgba(255,255,255,0.02); border: 1px solid var(--glass-border); border-radius: 12px; cursor: pointer;" ondblclick="window.open('${d.driveFileLink}', '_blank')" title="Doble clic para abrir">
      <div style="background: var(--secondary-color); color: #1a237e; width: 45px; height: 45px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.8rem;">
        ${String(d.folioNumber || 0).padStart(3, '0')}
      </div>
      <div style="flex: 1;">
        <h5 style="font-size: 0.95rem; margin-bottom: 2px;">${d.title}</h5>
        <p style="font-size: 0.7rem; color: var(--text-muted); font-family: monospace;">${d.standardizedName || 'Original file'}</p>
      </div>
      <div style="display: flex; gap: 8px;">
        <button onclick="event.stopPropagation(); window.open('${d.driveFileLink}', '_blank')" style="padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--glass-border); background: transparent; color: white; font-size: 0.75rem; cursor: pointer;">Ver</button>
        <button onclick="event.stopPropagation(); navigator.clipboard.writeText('${d.driveFileLink}').then(() => alert('Link copiado al portapapeles'))" style="padding: 0.5rem; background: rgba(59, 130, 246, 0.1); border: 1px solid rgba(59, 130, 246, 0.3); border-radius: 8px; color: #60a5fa; cursor: pointer;" title="Copiar Link para NotebookLM">🔗</button>
      </div>
    </div>
    `).join('');

  } catch (err) {
    list.innerHTML = `<p style="color: #ef4444;">Error al cargar el índice documental.</p>`;
  }
}

// --- INLINE CATEGORY SELECTOR ---
function renderInlineCategorySelector(action) {
  const CATEGORIES_OPTIONS = ['GENERAL', 'RESOLUCIONES', 'PRUEBAS', 'HECHOS', 'LEGISLACION', 'JURISPRUDENCIA', 'NOTIFICACIONES', 'COPIAS_EXPEDIENTE'];
  const currentCat = Array.isArray(action.category) ? action.category[0] : (action.category || 'GENERAL');

  // Generate options
  const optionsHTML = CATEGORIES_OPTIONS.map(cat =>
    `<option value="${cat}" ${cat === currentCat ? 'selected' : ''} style="background: #0f172a; color: white;">${cat}</option>`
  ).join('');

  return `
      <select onchange="updateActionCategory('${action.caseId || state.currentCase.id}', '${action.id}', this.value)"
    style="background: #0f172a; color: #fbbf24; border: 1px solid #fbbf24; border-radius: 4px; padding: 4px 8px; font-size: 0.75rem; font-weight: 700; cursor: pointer; outline: none; max-width: 100%; box-shadow: 0 2px 5px rgba(0,0,0,0.5);">
      ${optionsHTML}
        </select>
      `;
}

// Global function for inline update
window.updateActionCategory = async (caseId, actionId, newCategory) => {
  try {
    await CaseService.updateAction(caseId, actionId, { category: [newCategory] });
    // No full reload, just toast or subtle feedback? For now, we prefer reload to update filters
    loadActions(caseId);
  } catch (e) {
    console.error(e);
    alert("Error actualizando categoría");
  }
};

// --- HELPER RENDERING FUNCTIONS ---
// getYouTubeId is already defined at line 143


function getFileIcon(fileName) {
  if (!fileName) return '📄';
  const ext = fileName.split('.').pop().toLowerCase();
  if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return '🖼️';
  if (['pdf'].includes(ext)) return '📕';
  if (['doc', 'docx'].includes(ext)) return '📝';
  if (['xls', 'xlsx', 'csv'].includes(ext)) return '📊';
  if (['mp3', 'wav', 'm4a', 'ogg'].includes(ext)) return '🎙️';
  if (['mp4', 'mov', 'avi'].includes(ext)) return '🎥';
  if (['zip', 'rar'].includes(ext)) return '📦';
  if (['eml', 'msg'].includes(ext)) return '📧';
  return '📄';
}

function renderActionCard(a) {
  const isAudio = a.driveFileName && /\.(mp3|wav|m4a|ogg)$/i.test(a.driveFileName);
  const isImage = a.driveFileName && /\.(jpg|jpeg|png|gif|webp)$/i.test(a.driveFileName);
  const isEmail = a.driveFileName && /\.(eml|msg)$/i.test(a.driveFileName);

  let contentHTML = '';

  // 1. YouTube Video
  if (a.youtubeLink) {
    const videoId = getYouTubeId(a.youtubeLink);
    contentHTML += videoId ? `
      <div style="margin-bottom: 1rem; border-radius: 8px; overflow: hidden; border: 1px solid var(--glass-border);">
        <iframe width="100%" height="200" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
      ` : `
      <div style="margin-bottom: 1rem;">
        <a href="${a.youtubeLink}" target="_blank" style="color: #60a5fa; text-decoration: underline; font-size: 0.8rem; display: flex; align-items: center; gap: 5px;">
          📺 Ver Video Relacionado
        </a>
            </div>
      `;
  }

  // 2. Audio Player
  if (isAudio && a.driveFileLink) {
    // Note: Google Drive direct links for audio can be tricky. Usually requires a proxy or specific export link.
    // For prototype, we show a player UI that opens the file.
    contentHTML += `
      <div style="margin-bottom: 1rem; background: rgba(0,0,0,0.2); padding: 0.8rem; border-radius: 8px; display: flex; align-items: center; gap: 10px;">
                <span style="font-size: 1.5rem;">🎙️</span>
                <div style="flex: 1;">
                    <p style="font-size: 0.7rem; color: var(--text-muted);">GRABACIÓN DE AUDIO</p>
                    <p style="font-size: 0.8rem; color: white;">${a.driveFileName}</p>
                </div>
                <button onclick="window.open('${a.driveFileLink}', '_blank')" style="background: var(--secondary-color); border: none; border-radius: 50%; width: 30px; height: 30px; cursor: pointer; display: flex; align-items: center; justify-content: center;">▶</button>
            </div>
      `;
  }

  // 3. Meet Link
  if (a.meetLink) {
    contentHTML += `
      <div style="margin-bottom: 1rem;">
        <button onclick="window.open('${a.meetLink}', '_blank')" style="background: rgba(16, 185, 129, 0.1); color: #10b981; border: 1px solid rgba(16, 185, 129, 0.2); padding: 0.5rem 1rem; border-radius: 8px; font-size: 0.75rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; width: 100%; justify-content: center;">
          🎥 UNIRSE A GOOGLE MEET
        </button>
            </div>
      `;
  }

  // 4. Map Location
  if (a.location && (a.location.includes('http') || a.location.length > 5)) {
    contentHTML += `
      <div style="margin-bottom: 0.8rem;">
        <button onclick="window.open('https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(a.location)}', '_blank')" style="background: rgba(59, 130, 246, 0.1); color: #60a5fa; border: 1px solid rgba(59, 130, 246, 0.2); padding: 0.4rem 0.8rem; border-radius: 6px; font-size: 0.7rem; cursor: pointer; display: flex; align-items: center; gap: 5px;">
          📍 ${a.location.substring(0, 30)}${a.location.length > 30 ? '...' : ''}
        </button>
            </div>
      `;
  }

  // 5. Description Text
  contentHTML += `
      <div style="background: rgba(255,255,255,0.02); padding: 1rem; border-radius: 10px; font-size: 0.85rem; color: #cbd5e1; line-height: 1.5; border: 1px solid var(--glass-border);">
        ${a.description.replace(/\n/g, '<br>')}
        </div>
      `;

  // 6. Email Metadata Badge
  if (isEmail) {
    contentHTML += `
      <div style="margin-top: 0.5rem; display: flex; justify-content: flex-end;">
        <span style="font-size: 0.65rem; background: rgba(239, 68, 68, 0.1); color: #ef4444; padding: 2px 6px; border-radius: 4px; border: 1px solid rgba(239, 68, 68, 0.2);">EVIDENCE: EMAIL THREAD</span>
             </div>
      `;
  }

  // Render Categories
  let cats = [];
  if (Array.isArray(a.category)) cats = a.category;
  else if (a.category) cats = [a.category];
  else cats = ['GENERAL'];

  const catBadges = cats.map(c => `
      <span style="font-size: 0.6rem; color: var(--text-muted); font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; margin-right: 5px; background: rgba(255,255,255,0.1); padding: 2px 6px; border-radius: 4px;">
        [${c}]
        </span>
      `).join('');

  return `
      <div style="position: relative; animation: fadeIn 0.5s ease-out; cursor: pointer;" ondblclick="window.open('${a.driveFileLink}', '_blank')" title="Doble clic para abrir documento">
        <div style="position: absolute; left: -31px; top: 0; width: 10px; height: 10px; background: var(--secondary-color); border-radius: 50%; box-shadow: 0 0 10px var(--secondary-color);"></div>
        <div style="display: flex; gap: 10px; align-items: flex-start; margin-bottom: 0.5rem;">
            <input type="checkbox" class="action-checkbox" value="${a.id}" onchange="toggleBulkToolbar()" onclick="event.stopPropagation()" style="width: 18px; height: 18px; cursor: pointer; accent-color: var(--secondary-color);">
            <div style="flex: 1;">
              <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                <div style="display: flex; flex-direction: column;">
                    <div style="margin-bottom: 2px;">${catBadges}</div>
                    <span style="font-size: 0.75rem; color: var(--secondary-color); font-weight: 700;">${new Date(a.timestamp?.seconds * 1000).toLocaleDateString()}</span>
                </div>
                <div style="display: flex; gap: 10px; align-items: center;">
                    <button onclick="event.stopPropagation(); navigator.clipboard.writeText('${a.driveFileLink}').then(() => alert('Link copiado al portapapeles'))" style="background: rgba(255,255,255,0.05); border: 1px solid var(--glass-border); color: var(--text-muted); cursor: pointer; font-size: 0.7rem; padding: 2px 6px; border-radius: 4px;" title="Copiar Link Drive">🔗 Copiar Link</button>
                    <button onclick="event.stopPropagation(); deleteAction('${a.caseId || state.currentCaseId}', '${a.id}')" style="background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); color: #ef4444; cursor: pointer; font-size: 0.7rem; padding: 2px 6px; border-radius: 4px;" title="Eliminar Actuación">🗑️</button>
                    <span style="font-size: 0.7rem; color: var(--text-muted);">${new Date(a.timestamp?.seconds * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                </div>
              </div>
            </div>
        </div>
        
        <!--INLINE CATEGORY SELECTOR-->
        <div style="margin-bottom: 0.8rem;" onclick="event.stopPropagation()">
             ${renderInlineCategorySelector(a)}
        </div>

        <h4 style="margin-bottom: 0.8rem; line-height: 1.3; font-size: 1rem;">
            ${getFileIcon(a.driveFileName)} ${a.driveFileName || a.title}
        </h4>
        ${contentHTML}
    </div>`;
}

async function loadActions(caseId, filterCategory = null) {
  const list = document.querySelector('#actions-list');
  // Add Filter UI if not present
  const filterContainer = document.querySelector('#actions-filters');
  if (!filterContainer) {
    // Insert filters before list
    const filtersHTML = `
      <div id="actions-filters" style="display: flex; gap: 8px; overflow-x: auto; padding-bottom: 1rem; margin-bottom: 1rem; border-bottom: 1px solid var(--glass-border);">
            <button onclick="loadActions('${caseId}', null)" class="filter-btn ${!filterCategory ? 'active' : ''}" style="white-space: nowrap;">TODOS</button>
            <button onclick="loadActions('${caseId}', 'RESOLUCIONES')" class="filter-btn ${filterCategory === 'RESOLUCIONES' ? 'active' : ''}">RESOLUCIONES ⚖️</button>
            <button onclick="loadActions('${caseId}', 'PRUEBAS')" class="filter-btn ${filterCategory === 'PRUEBAS' ? 'active' : ''}">PRUEBAS 🔎</button>
            <button onclick="loadActions('${caseId}', 'HECHOS')" class="filter-btn ${filterCategory === 'HECHOS' ? 'active' : ''}">HECHOS 📌</button>
            <button onclick="loadActions('${caseId}', 'LEGISLACION')" class="filter-btn ${filterCategory === 'LEGISLACION' ? 'active' : ''}">LEGISLACIÓN 📜</button>
            <button onclick="loadActions('${caseId}', 'JURISPRUDENCIA')" class="filter-btn ${filterCategory === 'JURISPRUDENCIA' ? 'active' : ''}">JURISPRUDENCIA 🏛️</button>
            <button onclick="loadActions('${caseId}', 'NOTIFICACIONES')" class="filter-btn ${filterCategory === 'NOTIFICACIONES' ? 'active' : ''}">NOTIFICACIONES 🔔</button>
             <button onclick="loadActions('${caseId}', 'COPIAS_EXPEDIENTE')" class="filter-btn ${filterCategory === 'COPIAS_EXPEDIENTE' ? 'active' : ''}">COPIAS 📂</button>
            
            <button class="filter-btn" style="border: 1px dashed var(--secondary-color); margin-left: auto;" onclick="window.open('${state.currentCase.driveFolderLink || 'https://drive.google.com'}', '_blank')">
                📤 Abrir Drive (NotebookLM)
            </button>
            <button class="filter-btn" style="border: 1px dashed #ef4444; color: #ef4444;" onclick="triggerBatchAnalysis('${caseId}')" title="Analizar documentos faltantes con IA">
                🧠 Re-analizar Docs
            </button>
        </div>
        
      <style>
        .filter-btn {background: transparent; border: 1px solid var(--glass-border); color: var(--text-muted); padding: 0.4rem 0.8rem; border-radius: 20px; font-size: 0.7rem; cursor: pointer; transition: all 0.2s; white-space: nowrap; }
        .filter-btn:hover {background: rgba(255,255,255,0.05); color: white; }
        .filter-btn.active {background: var(--secondary-color); color: #0a0f1e; font-weight: 800; border-color: var(--secondary-color); }
      </style>
    `;
    list.insertAdjacentHTML('beforebegin', filtersHTML);

    // Crear barra flotante si no existe
    initBulkActionsToolbar();
  } else {
    // Update active state
    document.querySelectorAll('.filter-btn').forEach(btn => {
      btn.classList.toggle('active',
        (btn.innerText.includes('TODOS') && !filterCategory) ||
        (btn.innerText.includes(filterCategory))
      );
    });
  }

  try {
    const actions = await CaseService.getActions(caseId);
    if (actions.length === 0) {
      list.innerHTML = `< p style = "color: var(--text-muted); font-style: italic;" > No hay actuaciones registradas en este expediente.</p > `;
      return;
    }

    const filtered = filterCategory ? actions.filter(a => {
      if (Array.isArray(a.category)) return a.category.includes(filterCategory);
      return a.category === filterCategory;
    }) : actions;

    if (filtered.length === 0) {
      list.innerHTML = `< p style = "color: var(--text-muted); font-style: italic; text-align:center; padding: 2rem;" > No hay items en la categoría ${filterCategory}</p > `;
      return;
    }

    list.innerHTML = filtered.map(a => renderActionCard(a)).join('');

  } catch (err) {
    list.innerHTML = `< p style = "color: #ef4444;" > Error al cargar actuaciones.</p > `;
  }
}



window.deleteAction = async (caseId, actionId) => {
  if (!confirm('¿Estás seguro de que deseas eliminar esta actuación del expediente?\n\nNota: El archivo en Drive no se borrará, solo el registro en el sistema.')) return;

  try {
    await CaseService.deleteAction(caseId, actionId);
    loadActions(caseId);
  } catch (error) {
    alert('Error al eliminar: ' + error.message);
  }
}

// BATCH ANALYSIS FUNCTION
// BATCH ANALYSIS TRIGGER
// BATCH ANALYSIS TRIGGER
window.triggerBatchAnalysis = async (caseId) => {
  const btn = document.getElementById('btn-analyze-docs');
  const originalText = btn ? btn.innerHTML : '';
  if (btn) btn.disabled = true;

  try {
    if (!state.user.apiKey) {
      alert("⚠️ No se ha configurado la API Key de Gemini.");
      return;
    }

    if (!confirm("¿Iniciar análisis profundo con Gemini para documentos faltantes?\n\nEsto puede tomar unos minutos sin cerrar la ventana.")) {
      return;
    }

    const actions = await CaseService.getActions(caseId);

    const toProcess = actions.filter(a =>
      a.driveFileLink &&
      (!a.aiAnalysis || a.aiAnalysis.error || (a.manualClassification?.clasificadoPor !== 'manual'))
    );

    if (toProcess.length === 0) {
      alert("✅ Todos los documentos ya están analizados o no tienen archivo adjunto.");
      return;
    }

    if (btn) btn.innerHTML = `⏳ Iniciando...`;
    let successCount = 0;
    let errorCount = 0;

    for (let i = 0; i < toProcess.length; i++) {
      const action = toProcess[i];
      if (btn) btn.innerHTML = `🧠 Analizando ${i + 1}/${toProcess.length}...`;

      try {
        const analysisResult = await analyzeScannedImageWithGemini(
          action.driveFileLink,
          action.driveFileName || action.title,
          state.user.apiKey,
          state.googleToken
        );

        if (analysisResult.success) {
          await CaseService.updateAction(caseId, action.id, {
            aiAnalysis: analysisResult.analysis
          });

          const timelineEvent = geminiAnalysisToTimelineEvent(analysisResult.analysis, {
            id: action.id,
            name: action.driveFileName || action.title,
            driveFileLink: action.driveFileLink
          });

          if (timelineEvent) {
            await TimelineService.createEvent(caseId, timelineEvent);
          }
          successCount++;
        } else {
          throw new Error(analysisResult.error || "Fallo desconocido en IA");
        }

      } catch (err) {
        console.error(`Error analizando ${action.title}:`, err);
        errorCount++;

        if (err.message.includes('403') || err.message.includes('401') || err.message.includes('Forbidden') || err.message.includes('Unauthorized')) {
          const shouldRelogin = confirm(`⚠️ DETENIDO: Error de permisos en documento "${action.title}".\n\nGoogle Drive denegó el acceso. Es probable que tu sesión haya caducado.\n\n¿Deseas RE-CONECTAR tu cuenta de Google ahora para continuar?`);

          if (shouldRelogin) {
            try {
              const { token } = await AuthService.loginWithGoogle();
              state.googleToken = token;
              alert("✅ Permisos actualizados. Reintentando documento...");
              i--;
              continue;
            } catch (loginErr) {
              alert("❌ Error de conexión: " + loginErr.message);
              break;
            }
          } else {
            if (!confirm("¿Continuar ignorando errores?")) break;
          }
        }
      }
    }

    alert(`🏁 Proceso finalizado.\n\n✅ Exitosos: ${successCount}\n❌ Fallidos: ${errorCount}`);
    loadActions(caseId);

  } catch (e) {
    console.error("Batch error:", e);
    alert("Error general en proceso masivo: " + e.message);
  } finally {
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = originalText;
    }
  }
}
// BULK ACTIONS LOGIC
function initBulkActionsToolbar() {
  if (document.getElementById('bulk-actions-toolbar')) {
    console.log('✅ Barra flotante ya existe');
    return;
  }

  console.log('🔨 Creando barra flotante...');

  const toolbar = document.createElement('div');
  toolbar.id = 'bulk-actions-toolbar';
  toolbar.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%) translateY(200%);
    background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
    border: 2px solid #c5a059;
    border-radius: 50px;
    padding: 1rem 2.5rem;
    display: flex;
    align-items: center;
    gap: 20px;
    box-shadow: 0 20px 60px rgba(197, 160, 89, 0.4), 0 0 0 1px rgba(255,255,255,0.1) inset;
    z-index: 9999;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    backdrop-filter: blur(20px);
  `;

  toolbar.innerHTML = `
    <span id="selected-count" style="color: #c5a059; font-weight: 800; font-size: 1rem; border-right: 2px solid #c5a059; padding-right: 20px; margin-right: 10px; text-transform: uppercase; letter-spacing: 1px;">0 SELECCIONADOS</span>
    <button onclick="executeBulkAction('whatsapp')" title="Enviar por WhatsApp" style="background: rgba(37, 211, 102, 0.15); border: 1px solid rgba(37, 211, 102, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">📱</button>
    <button onclick="executeBulkAction('telegram')" title="Enviar por Telegram" style="background: rgba(0, 136, 204, 0.15); border: 1px solid rgba(0, 136, 204, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">🛩️</button>
    <button onclick="executeBulkAction('email')" title="Enviar por Correo" style="background: rgba(59, 130, 246, 0.15); border: 1px solid rgba(59, 130, 246, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">📧</button>
    <button onclick="executeBulkAction('print')" title="Imprimir Lista" style="background: rgba(148, 163, 184, 0.15); border: 1px solid rgba(148, 163, 184, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">🖨️</button>
    <div style="width: 2px; height: 30px; background: #c5a059; opacity: 0.3; border-radius: 2px;"></div>
    <button onclick="executeBulkAction('promote_to_writing')" title="Pasar a Redacción" style="background: rgba(168, 85, 247, 0.15); border: 1px solid rgba(168, 85, 247, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">✍️</button>
    <div style="width: 2px; height: 30px; background: #c5a059; opacity: 0.3; border-radius: 2px;"></div>
    <button onclick="executeBulkAction('delete')" title="Eliminar Seleccionados" style="background: rgba(239, 68, 68, 0.15); border: 1px solid rgba(239, 68, 68, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; color: #ef4444; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">🗑️</button>
  `;

  document.body.appendChild(toolbar);
  console.log('✅ Barra creada y agregada al body');
}

window.toggleBulkToolbar = () => {
  const checkboxes = document.querySelectorAll('.action-checkbox:checked');
  const toolbar = document.getElementById('bulk-actions-toolbar');
  const countSpan = document.getElementById('selected-count');

  console.log('🔧 toggleBulkToolbar llamada:', {
    checkboxesCount: checkboxes.length,
    toolbarExists: !!toolbar,
    countSpanExists: !!countSpan
  });

  if (!toolbar) {
    console.error('❌ bulk-actions-toolbar no encontrado en el DOM');
    return;
  }

  if (checkboxes.length > 0) {
    toolbar.style.transform = 'translateX(-50%) translateY(0)';
    if (countSpan) countSpan.innerText = `${checkboxes.length} Seleccionados`;
    console.log('✅ Barra mostrada con', checkboxes.length, 'elementos');
  } else {
    toolbar.style.transform = 'translateX(-50%) translateY(200%)';
    console.log('⬇️ Barra ocultada');
  }
}

window.executeBulkAction = async (actionType) => {
  const checkboxes = Array.from(document.querySelectorAll('.action-checkbox:checked'));
  if (checkboxes.length === 0) return;

  // Get full action objects from DOM or rebuild minimal info
  const selectedIds = checkboxes.map(cb => cb.value);

  // Context for messages (grab title from card if needed, complicated from just ID)
  // For simplicity, we process based on ID.

  if (actionType === 'delete') {
    if (!confirm(`¿Eliminar ${selectedIds.length} elementos seleccionados ? `)) return;
    try {
      for (const id of selectedIds) {
        await CaseService.deleteAction(state.currentCaseId, id);
      }
      loadActions(state.currentCaseId);
      document.getElementById('bulk-actions-toolbar').style.transform = 'translateY(150%)';
    } catch (e) { alert('Error eliminando: ' + e.message); }
  }

  if (actionType === 'whatsapp') {
    try {
      const allActions = await CaseService.getActions(state.currentCaseId);
      const selectedDocs = allActions.filter(a => selectedIds.includes(a.id));

      let text = `📁 *Documentos del Caso:* ${state.currentCase.title}\n`;
      text += `🆔 *ID Judicial:* ${state.currentCase.judicialId || 'N/A'}\n\n`;

      selectedDocs.forEach((doc, index) => {
        text += `${index + 1}. *${doc.driveFileName || doc.title}*\n`;
        if (doc.driveFileLink) {
          text += `   🔗 ${doc.driveFileLink}\n`;
        }
        text += `\n`;
      });

      text += `\n_Enviado desde Control Legal Total_`;

      window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
    } catch (e) {
      alert('Error al preparar WhatsApp: ' + e.message);
    }
  }

  if (actionType === 'telegram') {
    try {
      const allActions = await CaseService.getActions(state.currentCaseId);
      const selectedDocs = allActions.filter(a => selectedIds.includes(a.id));

      let text = `📁 Documentos del Caso: ${state.currentCase.title}\n`;
      text += `🆔 ID Judicial: ${state.currentCase.judicialId || 'N/A'}\n\n`;

      selectedDocs.forEach((doc, index) => {
        text += `${index + 1}. ${doc.driveFileName || doc.title}\n`;
        if (doc.driveFileLink) {
          text += `   🔗 ${doc.driveFileLink}\n`;
        }
        text += `\n`;
      });

      text += `\nEnviado desde Control Legal Total`;

      window.open(`https://t.me/share/url?url=${encodeURIComponent('https://lexocontrol.web.app')}&text=${encodeURIComponent(text)}`, '_blank');
    } catch (e) {
      alert('Error al preparar Telegram: ' + e.message);
    }
  }

  if (actionType === 'email') {
    try {
      const allActions = await CaseService.getActions(state.currentCaseId);
      const selectedDocs = allActions.filter(a => selectedIds.includes(a.id));

      const subject = `Documentos Caso: ${state.currentCase.title}`;
      let body = `Documentos del Caso: ${state.currentCase.title}\n`;
      body += `ID Judicial: ${state.currentCase.judicialId || 'N/A'}\n\n`;
      body += `Documentos adjuntos:\n\n`;

      selectedDocs.forEach((doc, index) => {
        body += `${index + 1}. ${doc.driveFileName || doc.title}\n`;
        if (doc.driveFileLink) {
          body += `   Link: ${doc.driveFileLink}\n`;
        }
        body += `\n`;
      });

      body += `\nEnviado desde Control Legal Total`;

      window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
    } catch (e) {
      alert('Error al preparar Email: ' + e.message);
    }
  }

  if (actionType === 'promote_to_writing') {
    if (!confirm(`¿Deseas copiar estos ${selectedIds.length} documentos al módulo de Redacción?`)) return;
    try {
      let count = 0;
      const allActions = await CaseService.getActions(state.currentCaseId); // Need full objects

      for (const id of selectedIds) {
        const action = allActions.find(a => a.id === id);
        if (action) {
          const writingData = {
            title: action.title || action.driveFileName || 'Documento Importado',
            type: 'IMPORTED', // Distinguir de escritos creados desde cero
            status: 'DRAFT',
            originalActionId: id,
            importedAt: new Date()
          };

          // Solo agregar gDocUrl si existe
          if (action.driveFileLink) {
            writingData.gDocUrl = action.driveFileLink;
          }

          await CaseService.addWriting(state.currentCaseId, writingData);
          count++;
        }
      }
      alert(`${count} documentos enviados a Redacción exitosamente.`);

      // Ocultar barra
      const toolbar = document.getElementById('bulk-actions-toolbar');
      if (toolbar) toolbar.style.transform = 'translateX(-50%) translateY(200%)';

      // Desmarcar checkboxes
      document.querySelectorAll('.action-checkbox:checked').forEach(cb => cb.checked = false);

    } catch (e) {
      console.error('Error completo:', e);
      alert('Error al pasar a redacción: ' + e.message);
    }
  }

  if (actionType === 'print') {
    alert('Preparando vista de impresión para ' + selectedIds.length + ' documentos...');
    // Mock print
    window.print();
  }
}

// Eliminamos el import duplicado de DriveService de esta zona
function showNewActionModal(caseId) {
  const modal = document.createElement('div');
  modal.id = 'action-modal-root';
  modal.style.cssText = `position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.85); backdrop-filter: blur(12px); display: flex; align-items: center; justify-content: center; z-index: 1000; overflow-y: auto; padding: 2rem 0;`;

  // Categories config
  // Categories config
  const CATEGORIES = ['GENERAL', 'RESOLUCIONES', 'PRUEBAS', 'HECHOS', 'LEGISLACION', 'JURISPRUDENCIA', 'NOTIFICACIONES', 'COPIAS_EXPEDIENTE'];

  modal.innerHTML = `
      <div class="glass-container" style="width: 90%; max-width: 700px; padding: 2rem 2.5rem; position: relative;">
            <h2 style="margin-bottom: 1.5rem; font-family: 'Outfit', sans-serif;" class="gold-text">Nueva Actuación / Prueba</h2>
            <form id="new-action-form" style="display: flex; flex-direction: column; gap: 1rem;">
                
                <!-- Main Metadata -->
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                    <div>
                        <label style="display: block; margin-bottom: 0.4rem; color: var(--text-muted); font-size: 0.7rem; font-weight: 700;">TÍTULO PRINCIPAL</label>
                        <input type="text" name="title" required placeholder="Ej: Aporte de Pruebas" style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white;">
                    </div>
                     <div>
                        <label style="display: block; margin-bottom: 0.4rem; color: var(--text-muted); font-size: 0.7rem; font-weight: 700;">VIDEO (YOUTUBE)</label>
                        <input type="url" name="youtubeLink" placeholder="https://youtube.com/..." style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white; font-size: 0.75rem;">
                    </div>
                </div>

                 <div>
                    <label style="display: block; margin-bottom: 0.4rem; color: var(--text-muted); font-size: 0.7rem; font-weight: 700;">DESCRIPCIÓN GENERAL</label>
                    <textarea name="description" required rows="2" placeholder="Descripción detallada o observaciones..." style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white; resize: none;"></textarea>
                </div>
                
                <!-- File Selection Area -->
                <div style="background: rgba(197, 160, 89, 0.05); padding: 1rem; border-radius: 10px; border: 1px dashed var(--secondary-color);">
                    <label style="display: block; margin-bottom: 0.8rem; color: var(--secondary-color); font-size: 0.75rem; font-weight: 800; text-align: center;">ÁREA DE CARGA Y CLASIFICACIÓN</label>
                    
                    <div style="display: flex; gap: 10px; flex-direction: column; margin-bottom: 1rem;">
                        <input type="file" id="action-files" multiple style="font-size: 0.7rem; color: var(--text-muted); padding: 0.5rem; background: rgba(0,0,0,0.2); border-radius: 5px; width: 100%;">
                        
                        <div style="display: flex; align-items: center; gap: 8px;">
                             <label for="action-folder" style="font-size: 0.7rem; color: var(--text-muted); padding: 0.5rem; background: rgba(0,0,0,0.2); border-radius: 5px; cursor: pointer; flex: 1; text-align: center; border: 1px dashed var(--glass-border); transition: background 0.2s;">
                                📁 Seleccionar Más Archivos
                             </label>
                             <input type="file" id="action-folder" multiple style="display: none;">
                        </div>
                    </div>

                    <!-- File List Container -->
                    <div id="file-list-container" style="display: none;">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; padding-bottom: 8px; border-bottom: 1px solid var(--glass-border);">
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <span style="font-size: 0.7rem; font-weight: bold; color: white;">Archivos Disponibles:</span>
                                <button type="button" id="select-all-files" style="font-size: 0.65rem; padding: 4px 8px; background: rgba(197, 160, 89, 0.2); border: 1px solid var(--secondary-color); border-radius: 4px; color: var(--secondary-color); cursor: pointer;">✓ Seleccionar Todos</button>
                                <button type="button" id="deselect-all-files" style="font-size: 0.65rem; padding: 4px 8px; background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 4px; color: #ef4444; cursor: pointer;">✗ Deseleccionar Todos</button>
                            </div>
                            <small class="gold-text" style="cursor: pointer; font-size: 0.65rem;" onclick="document.getElementById('action-files').value=''; document.getElementById('action-folder').value=''; document.getElementById('file-list-container').style.display='none'; document.getElementById('files-table-body').innerHTML='';">🗑️ Limpiar</small>
                        </div>
                        <div id="files-table-body" style="display: flex; flex-direction: column; gap: 8px; max-height: 300px; overflow-y: auto; padding-right: 5px;">
                            <!-- JS Generated Rows -->
                        </div>
                        <div id="selection-summary" style="margin-top: 10px; padding: 8px; background: rgba(197, 160, 89, 0.1); border-radius: 6px; text-align: center; font-size: 0.7rem; color: var(--secondary-color); font-weight: 700;">
                            0 archivos seleccionados para subir
                        </div>
                    </div>
                </div>

                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                    <div>
                        <label style="display: block; margin-bottom: 0.4rem; color: var(--text-muted); font-size: 0.7rem; font-weight: 700;">UBICACIÓN (MAPA)</label>
                        <input type="text" name="location" placeholder="Link de Google Maps o Dirección" style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white; font-size: 0.75rem;">
                    </div>
                    <!-- Calendar Options -->
                    <div>
                        <label style="display: block; margin-bottom: 0.4rem; color: var(--text-muted); font-size: 0.7rem; font-weight: 700;">AGENDAR</label>
                        <input type="datetime-local" name="eventDateTime" style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white; font-size: 0.8rem;">
                    </div>
                </div>

               <div style="display: flex; gap: 15px; justify-content: flex-end; align-items: center;">
                     <label style="display: flex; align-items: center; gap: 8px; color: var(--text-muted); font-size: 0.7rem; cursor: pointer;">
                        <input type="checkbox" name="isDeadline" style="width: 16px; height: 16px;"> ¿Plazo Fatal?
                    </label>
                    <label style="display: flex; align-items: center; gap: 8px; color: #60a5fa; font-size: 0.7rem; cursor: pointer;">
                        <input type="checkbox" name="useMeet" style="width: 16px; height: 16px;"> Crear Meet
                    </label>
               </div>

                <div style="display: flex; gap: 10px; margin-top: 1rem;">
                    <button type="button" id="cancel-action" style="flex: 1; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: transparent; color: white;">Cancelar</button>
                    <button type="submit" id="submit-action-btn" style="flex: 2; background: var(--secondary-color); color: #1a237e; padding: 0.8rem; border-radius: 8px; border: none; font-weight: 800; cursor: pointer;">GUARDAR TODO</button>
                </div>
            </form>
        </div >
      `;

  document.body.appendChild(modal);
  const form = document.querySelector('#new-action-form');
  const btn = document.querySelector('#submit-action-btn');
  const filesInput = document.querySelector('#action-files');
  const folderInput = document.querySelector('#action-folder');
  const fileListContainer = document.querySelector('#file-list-container');
  const filesTableBody = document.querySelector('#files-table-body');

  let selectedFilesMap = new Map(); // Store file object -> selected categories
  let fileSelectionMap = new Map(); // Store file object -> boolean (selected to upload)

  const updateSelectionSummary = () => {
    const summary = document.getElementById('selection-summary');
    const selectedCount = Array.from(fileSelectionMap.values()).filter(Boolean).length;
    if (summary) {
      summary.textContent = `${selectedCount} archivo${selectedCount !== 1 ? 's' : ''} seleccionado${selectedCount !== 1 ? 's' : ''} para subir`;
    }
  };

  const renderFileList = () => {
    filesTableBody.innerHTML = '';
    const allFiles = [...(filesInput.files || []), ...(folderInput.files || [])];

    if (allFiles.length > 0) {
      fileListContainer.style.display = 'block';
    } else {
      fileListContainer.style.display = 'none';
      return;
    }

    allFiles.forEach((file, index) => {
      // Init categories if not present
      if (!selectedFilesMap.has(file)) selectedFilesMap.set(file, ['GENERAL']); // Default
      if (!fileSelectionMap.has(file)) fileSelectionMap.set(file, true); // Default: selected

      const fileRow = document.createElement('div');
      const isSelected = fileSelectionMap.get(file);
      fileRow.style.cssText = `background: ${isSelected ? 'rgba(197, 160, 89, 0.08)' : 'rgba(0, 0, 0, 0.3)'}; padding: 10px; border-radius: 6px; display: flex; flex-direction: column; gap: 5px; border: 1px solid ${isSelected ? 'var(--secondary-color)' : 'var(--glass-border)'}; transition: all 0.2s;`;

      const currentCats = selectedFilesMap.get(file);

      // Checkbox generators for categories
      const catCheckboxes = CATEGORIES.map(cat => {
        const isChecked = currentCats.includes(cat) ? 'checked' : '';
        return `
      <label style="cursor: pointer; display: flex; align-items: center; gap: 4px; font-size: 0.65rem; color: ${isChecked ? 'white' : 'var(--text-muted)'}; background: ${isChecked ? 'rgba(197, 160, 89, 0.2)' : 'transparent'}; padding: 2px 5px; border-radius: 4px; border: 1px solid ${isChecked ? 'var(--secondary-color)' : 'transparent'}; transition: all 0.2s;">
        <input type="checkbox" value="${cat}" data-file-index="${index}" ${isChecked} style="display: none;" onchange="updateFileCategory(${index}, '${cat}', this.checked)">
          ${cat}
        </label>
    `;
      }).join('');

      fileRow.innerHTML = `
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <input type="checkbox" ${isSelected ? 'checked' : ''} onchange="toggleFileSelection(${index}, this.checked)" style="width: 16px; height: 16px; cursor: pointer; accent-color: var(--secondary-color);">
                    <span style="font-size: 0.75rem; font-weight: 600; color: ${isSelected ? 'white' : 'var(--text-muted)'}; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 200px;">${getFileIcon(file.name)} ${file.name}</span>
                </div>
                <span style="font-size: 0.65rem; color: var(--text-muted);">${(file.size / 1024).toFixed(1)} KB</span>
            </div>
      <div style="display: flex; flex-wrap: wrap; gap: 4px; ${!isSelected ? 'opacity: 0.4; pointer-events: none;' : ''}">
        ${catCheckboxes}
      </div>
    `;
      filesTableBody.appendChild(fileRow);
    });

    updateSelectionSummary();
  };

  // Toggle file selection
  window.toggleFileSelection = (fileIndex, isSelected) => {
    const allFiles = [...(filesInput.files || []), ...(folderInput.files || [])];
    const file = allFiles[fileIndex];
    if (!file) return;

    fileSelectionMap.set(file, isSelected);
    renderFileList();
  };

  // Global handler for checkbox changes (accessed via inline onchange)
  window.updateFileCategory = (fileIndex, category, isChecked) => {
    const allFiles = [...(filesInput.files || []), ...(folderInput.files || [])];
    const file = allFiles[fileIndex];
    if (!file) return;

    let cats = selectedFilesMap.get(file) || [];
    if (isChecked) {
      if (!cats.includes(category)) cats.push(category);
      // If checking specific, remove GENERAL if present (optional UX choice)
    } else {
      cats = cats.filter(c => c !== category);
    }
    if (cats.length === 0) cats = ['GENERAL']; // Fallback
    selectedFilesMap.set(file, cats);

    // Re-render to update styles (lazy way)
    renderFileList();
  };

  filesInput.addEventListener('change', renderFileList);
  folderInput.addEventListener('change', renderFileList);

  // Select/Deselect all buttons
  document.getElementById('select-all-files').addEventListener('click', () => {
    const allFiles = [...(filesInput.files || []), ...(folderInput.files || [])];
    allFiles.forEach(file => fileSelectionMap.set(file, true));
    renderFileList();
  });

  document.getElementById('deselect-all-files').addEventListener('click', () => {
    const allFiles = [...(filesInput.files || []), ...(folderInput.files || [])];
    allFiles.forEach(file => fileSelectionMap.set(file, false));
    renderFileList();
  });


  document.querySelector('#cancel-action').addEventListener('click', () => modal.remove());

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    btn.disabled = true;
    btn.innerText = 'PROCESANDO...';

    const formData = new FormData(form);
    const baseData = Object.fromEntries(formData.entries());
    const allFiles = [...(filesInput.files || []), ...(folderInput.files || [])];

    try {
      let meetLink = null;

      // 1. Calendar Event logic
      if (baseData.eventDateTime && state.googleToken) {
        btn.innerText = 'AGENDANDO...';
        const start = new Date(baseData.eventDateTime);
        const end = new Date(start.getTime() + 60 * 60 * 1000);

        const event = await CalendarService.createEvent({
          title: `[ACTUACIÓN] ${baseData.title} `,
          description: baseData.description,
          location: baseData.location,
          start: start.toISOString(),
          end: end.toISOString()
        }, state.googleToken, baseData.useMeet === 'on');

        if (event.hangoutLink) meetLink = event.hangoutLink;
        baseData.eventLink = event.htmlLink;
      }

      // 2. File Upload Loop with ROBUST ERROR HANDLING
      const results = { success: 0, failed: 0, errors: [] };

      // Filter only selected files
      const selectedFiles = allFiles.filter(file => fileSelectionMap.get(file) === true);

      if (selectedFiles.length > 0 && state.googleToken) {
        let index = 0;
        for (const file of selectedFiles) {
          index++;
          btn.innerText = `SUBIENDO ${index}/${selectedFiles.length}...`;

          try {
            // DUPLICATE CHECK
            const isDupe = await CaseService.checkDuplicateFile(caseId, file.name);
            if (isDupe) {
              // We use a non-blocking approach for bulk: just log it or skip if desired.
              // For now, we auto-skip if duplicate to allow bulk flow, or append (Copy).
              // Let's append timestamp to duplicate names to ensure preservation without blocking.
              console.warn(`Duplicate found: ${file.name}, processing anyway.`);
            }

            // Get Categories for this specific file
            const fileCategories = selectedFilesMap.get(file) || ['GENERAL'];
            const primaryCategory = fileCategories[0];

            // Folder Mapping
            let targetFolderName = 'root';
            if (primaryCategory === 'PRUEBAS') targetFolderName = '01_PRUEBAS';
            if (primaryCategory === 'RESOLUCIONES') targetFolderName = '02_AUTOS_JUDICIALES';
            if (primaryCategory === 'LEGISLACION' || primaryCategory === 'JURISPRUDENCIA') targetFolderName = '02_AUTOS_JUDICIALES';
            if (primaryCategory === 'NOTIFICACIONES' || primaryCategory === 'COPIAS_EXPEDIENTE') targetFolderName = '02_AUTOS_JUDICIALES';

            let targetFolderId = state.currentCase.driveFolderId;
            if (state.currentCase.folders && state.currentCase.folders[targetFolderName]) {
              targetFolderId = state.currentCase.folders[targetFolderName];
            }

            // Upload
            const nextFolio = await CaseService.getNextFolioNumber(caseId);
            const folioStr = String(nextFolio).padStart(3, '0');
            const customName = `[${primaryCategory}] ${folioStr} - ${file.name}`;

            const driveFile = await DriveService.uploadFile(file, state.googleToken, targetFolderId, customName);

            // Create Item
            // Extract Date from Filename (Apps Script Plan B Support)
            const extractedDate = extractDateFromFilename(file.name);
            const actionDate = extractedDate || new Date();

            const newActionId = await CaseService.addAction(caseId, {
              ...baseData,
              // Simple title for UI, robust name for Drive
              title: selectedFiles.length > 1 ? file.name : baseData.title,
              description: baseData.description + (meetLink ? `\n\n🎥 Meet: ${meetLink}` : ''),
              category: fileCategories,
              createdTime: actionDate, // Use extracted date or now
              driveFileId: driveFile.id,
              driveFileName: file.name,
              driveFileLink: DriveService.getFileLink(driveFile.id),
              folioNumber: nextFolio,
              standardizedName: customName,
              meetLink: meetLink,
              author: state.user.displayName
            });

            results.success++;

            // --- GEMINI DEEP ANALYSIS INTEGRATION ---
            // Trigger analysis immediately after upload
            if (state.user?.apiKey) {
              console.log(`🧠 Iniciando análisis profundo con Gemini para: ${file.name}`);

              // Update UI to show analysis is happening (optional, console for now)
              btn.innerText = `ANALIZANDO ${index}/${selectedFiles.length}...`;

              analyzeScannedImageWithGemini(
                DriveService.getFileLink(driveFile.id), // Use Link
                file.name,
                state.user.apiKey,
                state.googleToken
              ).then(async (analysisResult) => {
                if (analysisResult.success) {
                  console.log(`✅ Análisis completado para ${file.name}`, analysisResult.analysis);

                  // 1. Update Action with Analysis
                  const aiDate = analysisResult.analysis.fecha_documento ? new Date(analysisResult.analysis.fecha_documento) : null;

                  await CaseService.updateAction(caseId, newActionId, { // FIXED: Use correct Firestore Doc ID
                    aiAnalysis: analysisResult.analysis,
                    ...(aiDate && { createdTime: aiDate }) // Update date if found by AI
                  });

                  // 2. Create Timeline Event
                  const timelineEvent = geminiAnalysisToTimelineEvent(analysisResult.analysis, {
                    id: newActionId, // Link to Firestore Doc
                    name: file.name,
                    driveFileLink: DriveService.getFileLink(driveFile.id)
                  });

                  if (timelineEvent) {
                    await TimelineService.createEvent(caseId, timelineEvent);
                    console.log('📅 Evento de línea de tiempo creado automáticamente');
                  }

                } else {
                  console.warn(`⚠️ Falló análisis Gemini para ${file.name}:`, analysisResult.error);
                }
              }).catch(err => console.error("Error crítico en pipeline Gemini:", err));
            } else {
              console.log("ℹ️ Saltando análisis Gemini: No API Key in state");
            }
            // ----------------------------------------

          } catch (fileErr) {
            console.error(`Error uploading file ${file.name}:`, fileErr);
            results.failed++;
            results.errors.push(`${file.name}: ${fileErr.message}`);
          }
        }
      } else {
        // Text-only action logic...
        await CaseService.addAction(caseId, {
          ...baseData,
          category: ['GENERAL'],
          meetLink: meetLink,
          author: state.user.displayName
        });
      }

      modal.remove();
      loadActions(caseId);
      state.currentCase = await CaseService.getCaseById(caseId);

      // Report
      if (allFiles.length > 0) {
        if (results.failed === 0) {
          alert(`✅ Operación Exitosa\n\nSe procesaron ${results.success} archivos correctamente.`);
        } else {
          alert(`⚠️ Operación Completada con Errores\n\nExitosos: ${results.success}\nFallidos: ${results.failed}\n\nErrores:\n${results.errors.join('\n')}`);
        }
      }

    } catch (err) {
      console.error(err);
      alert('Error: ' + err.message);
    } finally {
      if (document.body.contains(modal)) {
        btn.disabled = false;
        btn.innerText = 'GUARDAR';
      }
    }
  });
}

// --- EDIT ACTION MODAL ---
async function showEditActionModal(caseId, actionId) {
  const actions = await CaseService.getActions(caseId);
  const action = actions.find(a => a.id === actionId);
  if (!action) return;

  const modal = document.createElement('div');
  modal.style.cssText = `position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.85); backdrop-filter: blur(12px); display: flex; align-items: center; justify-content: center; z-index: 1000;`;

  // Flatten categories
  let currentCats = [];
  if (Array.isArray(action.category)) currentCats = action.category;
  else if (action.category) currentCats = [action.category];
  else currentCats = ['GENERAL'];

  const CATEGORIES = ['GENERAL', 'RESOLUCIONES', 'PRUEBAS', 'HECHOS', 'LEYES', 'DECRETOS', 'NOTIFICACIONES', 'COPIAS_EXPEDIENTE'];

  const catCheckboxes = CATEGORIES.map(cat => {
    const isChecked = currentCats.includes(cat) ? 'checked' : '';
    return `
            <label style="cursor: pointer; display: flex; align-items: center; gap: 8px; font-size: 0.8rem; color: white; background: rgba(255,255,255,0.05); padding: 8px; border-radius: 6px; border: 1px solid ${isChecked ? 'var(--secondary-color)' : 'transparent'};">
                <input type="checkbox" name="categories" value="${cat}" ${isChecked} style="accent-color: var(--secondary-color);">
                ${cat}
            </label>
        `;
  }).join('');

  modal.innerHTML = `
    <div class="glass-container" style="width: 90%; max-width: 500px; padding: 2rem; position: relative;">
        <h3 style="margin-bottom: 1.5rem; color: var(--secondary-color);">Editar Actuación</h3>
        <form id="edit-action-form" style="display: flex; flex-direction: column; gap: 1rem;">
            
            <div>
                <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.75rem;">TÍTULO</label>
                <input type="text" name="title" value="${action.title || ''}" required style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white;">
            </div>

            <div>
                 <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.75rem;">CATEGORÍAS (SELECCIÓN MÚLTIPLE)</label>
                 <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
                    ${catCheckboxes}
                 </div>
            </div>

            <div>
                <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.75rem;">DESCRIPCIÓN</label>
                <textarea name="description" rows="3" style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white; resize: none;">${action.description || ''}</textarea>
            </div>

            <div style="display: flex; gap: 10px; margin-top: 1rem;">
                <button type="button" id="cancel-edit" style="flex: 1; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: transparent; color: white; cursor: pointer;">Cancelar</button>
                <button type="submit" style="flex: 2; background: var(--secondary-color); color: #1a237e; padding: 0.8rem; border-radius: 8px; border: none; font-weight: 800; cursor: pointer;">GUARDAR CAMBIOS</button>
            </div>
        </form>
    </div>
    `;

  document.body.appendChild(modal);

  document.getElementById('cancel-edit').onclick = () => modal.remove();

  document.getElementById('edit-action-form').onsubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    // Get selected categories
    const selectedCats = [];
    modal.querySelectorAll('input[name="categories"]:checked').forEach(cb => {
      selectedCats.push(cb.value);
    });

    const updateData = {
      title: formData.get('title'),
      description: formData.get('description'),
      category: selectedCats.length > 0 ? selectedCats : ['GENERAL']
    };

    try {
      await CaseService.updateAction(caseId, actionId, updateData);
      modal.remove();
      loadActions(caseId); // Refresh list
    } catch (err) {
      alert("Error actualizando: " + err.message);
    }
  };
}

// --- VISTA: NUEVO EXPEDIENTE ---
function showNewCaseModal(parentId = null, parentTitle = null) {
  const modal = document.createElement('div');
  modal.id = 'modal-container';
  modal.style = `position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.85); backdrop-filter: blur(12px); display: flex; align-items: center; justify-content: center; z-index: 1000;`;

  const isSubCase = !!parentId;
  const titleText = isSubCase ? `Nuevo Incidente / Pieza` : `Nuevo Expediente Principal`;
  const parentInfoHTML = isSubCase ?
    `<div style="background: rgba(197, 160, 89, 0.1); border: 1px solid var(--primary-gold); padding: 1rem; border-radius: 8px; margin-bottom: 2rem;">
        <span style="display: block; font-size: 0.7rem; color: var(--primary-gold); font-weight: 800; text-transform: uppercase;">VINCULADO A EXPEDIENTE PRINCIPAL</span>
        <span style="font-size: 1rem; color: white;">${parentTitle}</span>
     </div>` : '';

  modal.innerHTML = `
    <div class="glass-container" style="width: 90%; max-width: 600px; padding: 3.5rem; position: relative; animation: modalIn 0.3s ease-out;">
            <button id="close-modal" style="position: absolute; top: 25px; right: 25px; background: none; border: none; color: white; font-size: 1.5rem; cursor: pointer; opacity: 0.5;">✕</button>
            <h2 style="margin-bottom: ${isSubCase ? '1rem' : '2.5rem'}; font-family: 'Outfit', sans-serif; font-size: 1.8rem;" class="gold-text">${titleText}</h2>
            ${parentInfoHTML}

  <form id="new-case-form" style="display: flex; flex-direction: column; gap: 1.5rem;">
    <input type="hidden" name="parentId" value="${parentId || ''}">
      <div>
        <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.75rem; font-weight: 700;">NOMBRE O CARÁTULA</label>
        <input type="text" name="title" required placeholder="${isSubCase ? 'Ej: Incidente de Nulidad' : 'Ej: Perez c/ Estado'}" style="width: 100%; padding: 1rem; border-radius: 10px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white;">
      </div>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
        <div>
          <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.75rem; font-weight: 700;">ID JUDICIAL</label>
          <input type="text" name="judicialId" placeholder="Ej: 24-009006-1027-CA" style="width: 100%; padding: 1rem; border-radius: 10px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white;">
        </div>
        <div>
          <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.75rem; font-weight: 700;">MATERIA</label>
          <select name="type" id="case-type-select" style="width: 100%; padding: 1rem; border-radius: 10px; border: 1px solid var(--glass-border); background: #0f172a; color: white;">
            <option value="CIVIL">CIVIL</option>
            <option value="FAMILIA">FAMILIA</option>
            <option value="PENAL">PENAL</option>
            <option value="LABORAL">LABORAL</option>
            <option value="ADMINISTRATIVO">ADMINISTRATIVO</option>
          </select>
        </div>
      </div>

      ${!isSubCase ? `
                <div style="background: rgba(197, 160, 89, 0.05); padding: 1rem; border-radius: 10px; border: 1px solid rgba(197, 160, 89, 0.2); margin-top: 0.5rem;">
                    <p style="font-size: 0.65rem; color: var(--secondary-color); font-weight: 800; margin-bottom: 5px;">BIBLIOTECA DE CONSULTA VINCULADA</p>
                    <p id="linked-library-name" style="font-size: 0.85rem; font-weight: 600;">Biblioteca Civil y Procesal</p>
                </div>
                ` : ''}

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
        <div>
          <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.75rem; font-weight: 700;">DIRECCIÓN NOTIFICACIÓN CLIENTE</label>
          <input type="text" name="clientAddress" placeholder="Dirección exacta o Google Maps URL" style="width: 100%; padding: 1rem; border-radius: 10px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white;">
        </div>
        <div>
          <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.75rem; font-weight: 700;">ID ÚNICO DEL CLIENTE (PARA ACCESO)</label>
          <input type="text" name="clientUid" placeholder="Copiar UID del cliente desde Perfiles" style="width: 100%; padding: 1rem; border-radius: 10px; border: 1px solid var(--secondary-color); background: rgba(255,255,255,0.03); color: white;">
        </div>
      </div>

      <div style="background: rgba(59, 130, 246, 0.05); padding: 1.5rem; border-radius: 15px; border: 1px solid rgba(59, 130, 246, 0.2);">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1rem;">
          <label style="display: flex; align-items: center; gap: 8px; color: #60a5fa; font-weight: 700; font-size: 0.8rem;">
            <span>☁️</span> VINCULAR INFRAESTRUCTURA EXISTENTE
          </label>
          <label class="switch" style="position: relative; display: inline-block; width: 40px; height: 20px;">
            <input type="checkbox" id="import-mode-toggle" onchange="toggleImportFields()">
              <span class="slider round" style="position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; border-radius: 34px;"></span>
          </label>
        </div>

        <div id="standard-infrastructure-info">
          <p style="font-size: 0.75rem; color: var(--text-muted);">El sistema creará automáticamente la estructura de carpetas en Google Drive y el Cuaderno Jurídico.</p>
          <label style="display: block; margin-top: 1rem; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.7rem; font-weight: 700;">NotebookLM URL (Opcional)</label>
          <input type="url" name="notebookLMUrl" placeholder="https://notebooklm.google.com/..." style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(0,0,0,0.2); color: white;">
        </div>

        <div id="import-infrastructure-fields" style="display: none; margin-top: 1rem; border-top: 1px dashed var(--glass-border); padding-top: 1rem;">
          <p style="font-size: 0.7rem; color: #10b981; margin-bottom: 1rem;">✅ Modo Importación: Se respetará la información existente.</p>

          <div style="margin-bottom: 1rem;">
            <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.7rem; font-weight: 700;">LINK DE CARPETA DRIVE EXISTENTE</label>
            <input type="url" name="existingDriveUrl" placeholder="https://drive.google.com/drive/folders/..." style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white;">
          </div>

          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: var(--text-muted); font-size: 0.7rem; font-weight: 700;">LINK CUADERNO NOTEBOOK LM EXISTENTE</label>
            <input type="url" name="existingNotebookUrl" placeholder="https://notebooklm.google.com/..." style="width: 100%; padding: 0.8rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.03); color: white;">
          </div>
        </div>

      <button type="submit" style="background: var(--secondary-color); color: #1a237e; padding: 1.2rem; border-radius: 10px; border: none; font-weight: 800; font-size: 1rem; margin-top: 1rem; cursor: pointer;">
        REGISTRAR EN CLOUD SEGURO
      </button>
  </form>
        </div>
    `;

  document.body.appendChild(modal);
  const typeSelect = document.querySelector('#case-type-select');
  const libraryLabel = document.querySelector('#linked-library-name');

  // Definir función en window para que el onchange HTML la encuentre
  window.toggleImportFields = () => {
    const isChecked = document.getElementById('import-mode-toggle').checked;
    document.getElementById('standard-infrastructure-info').style.display = isChecked ? 'none' : 'block';
    document.getElementById('import-infrastructure-fields').style.display = isChecked ? 'block' : 'none';
  };

  if (typeSelect && libraryLabel) {
    typeSelect.addEventListener('change', (e) => {
      const lib = LEGAL_LIBRARIES[e.target.value];
      libraryLabel.innerText = lib ? lib.name : 'Biblioteca General';
    });
  }

  document.querySelector('#close-modal').addEventListener('click', () => modal.remove());

  document.querySelector('#new-case-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const btnSubmit = e.target.querySelector('button');
    btnSubmit.disabled = true;
    btnSubmit.innerText = 'PROCESANDO SOLICITUD...';

    const data = Object.fromEntries(new FormData(e.target).entries());
    data.ethicalWall = [state.user.uid];
    data.createdAt = new Date();
    data.lastDocIndex = 0;

    // Handle parentId correctly (if empty string, set to null)
    if (!data.parentId) delete data.parentId;

    // Check Import Mode
    const isImportMode = document.getElementById('import-mode-toggle').checked;

    // Asignar biblioteca basada en materia (solo si es principal)
    if (!data.parentId) {
      const library = LEGAL_LIBRARIES[data.type];
      if (library) {
        data.libraryNotebookUrl = library.url;
        data.libraryName = library.name;
      }
    }

    // Mapping for Import Mode
    if (isImportMode) {
      if (data.existingNotebookUrl) {
        data.notebookLMUrl = data.existingNotebookUrl; // Override standard field
      }
    }

    try {
      if (state.googleToken) {

        if (isImportMode && data.existingDriveUrl) {
          // --- MODO IMPORTACIÓN ---
          // Extraer ID de la URL
          // Formatos comunes: https://drive.google.com/drive/folders/1A2B3C...?usp=sharing
          const match = data.existingDriveUrl.match(/folders\/([-a-zA-Z0-9_]+)/);
          if (match && match[1]) {
            data.driveFolderId = match[1];
            data.driveFolderLink = data.existingDriveUrl;

            // Opcional: Podríamos intentar leer subcarpetas aquí para rellenar data.folders, 
            // pero por simplicidad y velocidad, asumimos que el usuario manejará la estructura manualmente
            // o que el sistema irá aprendiendo.
            data.folders = { importedRoot: match[1] };
          } else {
            throw new Error("URL de Drive inválida. No se pudo extraer el ID de la carpeta.");
          }

        } else {
          // --- MODO CREACIÓN (STANDARD) ---
          // A. Carpeta Principal / Subcarpeta
          let folderName = `[EXP] ${data.judicialId || 'S-N'} - ${data.title} `;
          let parentFolderId = null;

          if (data.parentId) {
            // Si es subcaso, buscamos la carpeta del padre
            const parentCase = await CaseService.getCaseById(data.parentId);
            parentFolderId = parentCase.driveFolderId;
            folderName = `[INC] ${data.title} `; // Prefijo diferente para incidentes
          }

          const folderId = await DriveService.createFolder(folderName, state.googleToken, parentFolderId);
          data.driveFolderId = folderId;
          data.driveFolderLink = `https://drive.google.com/drive/folders/${folderId}`;

          // B. Estructura de Sub-Carpetas Oficiales
          const subfolders = ['01_PRUEBAS', '02_AUTOS_JUDICIALES', '03_ESCRITOS'];
          data.folders = {}; // Guardar IDs para uso futuro

          for (const sub of subfolders) {
            const subId = await DriveService.createFolder(sub, state.googleToken, folderId);
            data.folders[sub] = subId;
          }
        }
      }

      await CaseService.createCase(data);
      modal.remove();

      // Refresh Logic based on view
      if (state.currentView === 'case-detail' && data.parentId) {
        // If we are inside a case and added a subcase, reload that case view
        renderCaseDetail();
      } else {
        loadCases();
      }

    } catch (err) {
      console.error(err);
      alert('Error en operación: ' + err.message);
    } finally {
      if (btnSubmit) {
        btnSubmit.disabled = false;
        btnSubmit.innerText = 'REGISTRAR EN CLOUD SEGURO';
      }
      // Expose globally
      window.showNewCaseModal = showNewCaseModal;
    }
  });
}

// --- DRAFTING MODULE FUNCTIONS ---

async function loadDraftingView(caseId) {
  const list = document.querySelector('#draftings-list');
  list.innerHTML = '<p style="color: var(--text-muted); font-style: italic;">Cargando proyectos de escrito...</p>';

  const writings = await CaseService.getWritings(caseId);

  if (writings.length === 0) {
    list.innerHTML = `
            <div style="text-align: center; padding: 2rem; border: 1px dashed var(--glass-border); border-radius: 12px;">
                <p style="color: var(--text-muted);">No hay escritos en proceso o presentados.</p>
            </div>
        `;
    return;
  }

  // Initialize bulk toolbar for writings if not exists
  initBulkActionsToolbarWritings();

  list.innerHTML = writings.map(w => {
    let statusColor = '#94a3b8'; // draft
    let statusLabel = 'BORRADOR';
    if (w.status === 'REVIEW') { statusColor = '#facc15'; statusLabel = 'EN REVISIÓN'; }
    if (w.status === 'SIGNED') { statusColor = '#60a5fa'; statusLabel = 'FIRMADO'; }
    if (w.status === 'FILED') { statusColor = '#4ade80'; statusLabel = 'PRESENTADO'; }

    return `
            <div style="background: rgba(255,255,255,0.03); border: 1px solid var(--glass-border); border-radius: 12px; padding: 1.5rem; position: relative;">
                <input type="checkbox" class="writing-checkbox" value="${w.id}" onchange="toggleBulkToolbarWritings()" onclick="event.stopPropagation()" style="position: absolute; top: 1rem; left: 1rem; width: 18px; height: 18px; cursor: pointer; accent-color: var(--secondary-color);">
                
                <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 1rem; padding-left: 30px;">
                    <div>
                         <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 0.5rem;">
                            <span style="font-size: 0.65rem; background: ${statusColor}20; color: ${statusColor}; padding: 2px 8px; border-radius: 4px; font-weight: 800; border: 1px solid ${statusColor}40;">${statusLabel}</span>
                            <span style="font-size: 0.7rem; color: var(--text-muted);">${w.type || 'ESCRITO'}</span>
                         </div>
                         <h4 style="margin: 0; font-size: 1.1rem; color: white;">${w.title}</h4>
                    </div>
                    <div style="text-align: right;">
                         <span style="font-size: 0.7rem; color: var(--text-muted);">Actualizado: ${new Date(w.updatedAt?.seconds * 1000).toLocaleDateString()}</span>
                    </div>
                </div>

                <div style="display: flex; gap: 1rem; flex-wrap: wrap; padding-left: 30px;">
                    ${w.gDocUrl ? `
                        <button onclick="window.open('${w.gDocUrl}', '_blank')" style="display: flex; align-items: center; gap: 6px; padding: 0.5rem 1rem; background: rgba(59, 130, 246, 0.1); color: #60a5fa; border: 1px solid rgba(59, 130, 246, 0.3); border-radius: 6px; cursor: pointer; font-size: 0.8rem;">
                            📝 Abrir Editor (Docs)
                        </button>
                    ` : ''}
                    
                    ${w.status !== 'FILED' ? `
                         <button onclick="showSubmissionModal('${caseId}', '${w.id}')" style="display: flex; align-items: center; gap: 6px; padding: 0.5rem 1rem; background: rgba(16, 185, 129, 0.1); color: #10b981; border: 1px solid rgba(16, 185, 129, 0.3); border-radius: 6px; cursor: pointer; font-size: 0.8rem;">
                            📤 Registrar Presentación
                        </button>
                    ` : `
                        <button onclick="window.open('${w.proofUrl}', '_blank')" style="display: flex; align-items: center; gap: 6px; padding: 0.5rem 1rem; background: rgba(255, 255, 255, 0.05); color: var(--text-muted); border: 1px solid var(--glass-border); border-radius: 6px; cursor: pointer; font-size: 0.8rem;">
                            ✅ Ver Constancia
                        </button>
                    `}
                </div>
            </div>
        `;
  }).join('');
}

window.showNewWritingModal = (caseId) => {
  const modal = document.createElement('div');
  modal.className = 'modal fade-in';
  modal.style.display = 'flex';
  modal.innerHTML = `
        <div class="glass-container" style="width: 90%; max-width: 500px; padding: 2rem;">
            <h3 style="margin-bottom: 1.5rem; color: var(--primary-gold);">Nuevo Escrito Procesal</h3>
            <form id="new-writing-form">
                <div class="form-group">
                    <label>Título del Escrito</label>
                    <input type="text" name="title" required placeholder="Ej: Contestación de Demanda..." style="width: 100%;">
                </div>
                <div class="form-group">
                    <label>Tipo</label>
                    <select name="type" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(0,0,0,0.3); color: white; border: 1px solid var(--glass-border);">
                        <option value="DEMANDA">Demanda</option>
                        <option value="CONTESTACION">Contestación</option>
                        <option value="PRUEBAS">Ofrecimiento de Pruebas</option>
                        <option value="ALEGATOS">Alegatos</option>
                        <option value="RECURSO">Recurso / Apelación</option>
                        <option value="TRAMITE">Escrito de Trámite</option>
                        <option value="OTRO">Otro</option>
                    </select>
                </div>
                <div style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: 2rem;">
                    <button type="button" class="btn-outline" onclick="this.closest('.modal').remove()">Cancelar</button>
                    <button type="submit" class="btn-gold">Crear Borrador</button>
                </div>
            </form>
        </div>
    `;
  document.body.appendChild(modal);

  modal.querySelector('form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('button[type="submit"]');
    btn.disabled = true;
    btn.innerText = "Creando...";

    const formData = new FormData(e.target);

    try {
      await CaseService.addWriting(caseId, {
        title: formData.get('title'),
        type: formData.get('type'),
        status: 'DRAFT',
        gDocUrl: 'https://docs.google.com/document/create',
      });

      modal.remove();
      loadDraftingView(caseId);

    } catch (err) {
      console.error(err);
      alert("Error creando escrito");
    }
  });
};

window.showSubmissionModal = (caseId, writingId) => {
  const modal = document.createElement('div');
  modal.className = 'modal fade-in';
  modal.style.display = 'flex';
  modal.innerHTML = `
        <div class="glass-container" style="width: 90%; max-width: 500px; padding: 2rem;">
            <h3 style="margin-bottom: 1.5rem; color: var(--primary-gold);">Registrar Presentación en Juzgado</h3>
            <p style="color: var(--text-muted); margin-bottom: 1rem;">Suba la constancia de ingreso (sello, screenshot, etc.)</p>
            <form id="submission-form">
                <div class="form-group">
                    <label>Archivo de Constancia</label>
                    <input type="file" name="file" required style="color: white;">
                </div>
                 <div class="form-group">
                    <label>Fecha Presentación</label>
                    <input type="date" name="date" required style="color: white; background: rgba(0,0,0,0.3); border: 1px solid var(--glass-border); padding: 0.5rem;">
                </div>
                <div style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: 2rem;">
                    <button type="button" class="btn-outline" onclick="this.closest('.modal').remove()">Cancelar</button>
                    <button type="submit" class="btn-gold" style="background: #10b981;">Registrar Presentación</button>
                </div>
            </form>
        </div>
    `;
  document.body.appendChild(modal);

  modal.querySelector('form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('button[type="submit"]');
    btn.disabled = true;
    btn.innerText = "Subiendo...";

    const file = e.target.querySelector('input[type="file"]').files[0];

    try {
      if (!state.googleToken) throw new Error("Requiere sesión de Google");

      // Upload Proof
      const folderId = state.currentCase.folders?.['03_ESCRITOS'] || state.currentCase.driveFolderId;
      const driveFile = await DriveService.uploadFile(file, state.googleToken, folderId, `[CONSTANCIA] ${file.name}`);

      // Update Writing Status
      await CaseService.updateWriting(caseId, writingId, {
        status: 'FILED',
        proofUrl: DriveService.getFileLink(driveFile.id),
        filedAt: new Date(),
        proofFileId: driveFile.id
      });

      modal.remove();
      loadDraftingView(caseId);

    } catch (err) {
      console.error(err);
      alert("Error: " + err.message);
      btn.disabled = false;
    }
  });
}

// --- VISTA: CALENDARIO ---
async function renderCalendar() {
  app.innerHTML = `
        <div style="min-height: 100vh; padding: 2rem;" class="premium-gradient">
            <header style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 3rem; max-width: 1400px; margin-left: auto; margin-right: auto;">
                <div>
                   <button onclick="state.currentView='dashboard'; renderApp();" style="background: none; border: none; color: var(--text-muted); cursor: pointer; display: flex; align-items: center; gap: 5px; margin-bottom: 0.5rem;">
                        ← VOLVER AL DASHBOARD
                   </button>
                    <h1 style="font-family: var(--font-title); font-size: 2.5rem;">Calendario Judicial</h1>
                    <p style="color: var(--text-muted); font-size: 1.1rem;">Seguimiento centralizado de plazos y audiencias.</p>
                </div>
                <div>
                    <button onclick="window.open('https://calendar.google.com', '_blank')" style="padding: 0.8rem 1.5rem; background: rgba(255,255,255,0.05); border: 1px solid var(--glass-border); color: white; border-radius: 8px; cursor: pointer; display: flex; align-items: center; gap: 8px;">
                        <span>📅</span> Ver en Google Calendar
                    </button>
                </div>
            </header>

            <main style="max-width: 1400px; margin: 0 auto; padding-bottom: 3rem;">
                <div id="calendar-events" style="display: flex; flex-direction: column; gap: 1.5rem;">
                    <div class="glass-container" style="padding: 4rem; text-align: center;">
                        <p style="color: var(--text-muted);">El calendario se está sincronizando con sus expedientes...</p>
                    </div>
                </div>
                ${getLegalWarningHTML()}
            </main>
        </div>
    `;

  // document.querySelector('#logout-btn').addEventListener('click', () => AuthService.logout()); // Removed as header handles it differently or not needed in this view layout specifically
  loadAllEvents();
}

async function loadAllEvents() {
  const container = document.querySelector('#calendar-events');
  try {
    const cases = await CaseService.getMyCases(state.user.uid);
    let allEvents = [];

    for (const c of cases) {
      const actions = await CaseService.getActions(c.id);
      // Filtrar acciones que tengan palabras clave de plazos o audiencias
      const relevant = actions.filter(a =>
        a.title.toLowerCase().includes('audiencia') ||
        a.title.toLowerCase().includes('vencimiento') ||
        a.title.toLowerCase().includes('plazo') ||
        a.isDeadline === true
      ).map(a => ({ ...a, caseTitle: c.title, caseId: c.id }));
      allEvents = [...allEvents, ...relevant];
    }

    if (allEvents.length === 0) {
      container.innerHTML = `
                <div class="glass-container" style="padding: 5rem; text-align: center; border: 1px dashed var(--glass-border);">
                    <p style="font-size: 1.2rem; color: var(--text-muted);">No hay eventos o plazos próximos registrados.</p>
                </div>
            `;
      return;
    }

    // Ordenar por fecha (más reciente arriba)
    allEvents.sort((a, b) => b.timestamp?.seconds - a.timestamp?.seconds);

    container.innerHTML = allEvents.map(e => `
            <div class="glass-container" style="padding: 1.5rem; display: flex; align-items: center; gap: 2rem; border-left: 4px solid ${e.title.toLowerCase().includes('audiencia') ? '#ef4444' : '#c5a059'};">
                <div style="text-align: center; min-width: 80px;">
                    <span style="display: block; font-size: 1.4rem; font-weight: 800;">${new Date(e.timestamp?.seconds * 1000).getDate()}</span>
                    <span style="font-size: 0.7rem; color: var(--text-muted); text-transform: uppercase;">${new Date(e.timestamp?.seconds * 1000).toLocaleDateString('es-CR', { month: 'short' })}</span>
                </div>
                <div style="flex: 1;">
                    <span style="font-size: 0.65rem; color: var(--secondary-color); font-weight: 800; text-transform: uppercase;">${e.caseTitle}</span>
                    <h3 style="font-size: 1.1rem; margin: 4px 0;">${e.title}</h3>
                    <p style="font-size: 0.85rem; color: var(--text-muted);">${e.description.substring(0, 100)}...</p>
                </div>
                <button onclick="openCase('${e.caseId}')" style="padding: 0.6rem 1.2rem; border-radius: 8px; border: 1px solid var(--glass-border); background: transparent; color: white; font-size: 0.8rem; font-weight: 600;">Ver Expediente</button>
            </div>
        `).join('');

  } catch (err) {
    container.innerHTML = `<p style="color: #ef4444;">Error al cargar el calendario.</p>`;
  }
}

async function renderAgendaView() {
  app.innerHTML = `
        <div style="min-height: 100vh; padding: 2rem;" class="premium-gradient">
            <header style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 3rem; max-width: 1400px; margin-left: auto; margin-right: auto;">
                <div>
                   <button onclick="state.currentView='dashboard'; renderApp();" style="background: none; border: none; color: var(--text-muted); cursor: pointer; display: flex; align-items: center; gap: 5px; margin-bottom: 0.5rem;">
                        ← VOLVER AL DASHBOARD
                   </button>
                   <h1 style="font-family: var(--font-title); font-size: 2.2rem; margin-bottom: 0.2rem;" class="gold-text">AGENDA & ESTRATEGIA</h1>
                   <p style="color: var(--text-muted); font-size: 0.9rem; letter-spacing: 1px;">CONTROL DE TIEMPOS PROCESALES</p>
                </div>
                
                <div style="display: flex; align-items: center; gap: 1rem;">
                    <button onclick="window.open('https://calendar.google.com', '_blank')" style="padding: 0.8rem 1.5rem; background: rgba(255,255,255,0.05); border: 1px solid var(--glass-border); color: white; border-radius: 8px; cursor: pointer; display: flex; align-items: center; gap: 8px;">
                        <span>📅</span> Google Calendar
                    </button>
                </div>
            </header>

            <main style="max-width: 1400px; margin: 0 auto; display: grid; grid-template-columns: 1fr 350px; gap: 2rem;">
                
                <!-- Main Timeline -->
                <section class="glass-container" style="padding: 2.5rem;">
                    <h2 style="font-size: 1.3rem; margin-bottom: 2rem; display: flex; align-items: center; gap: 10px;">
                        <span>⏳</span> Línea de Tiempo Judicial
                    </h2>
                    
                    <div id="agenda-list" style="display: flex; flex-direction: column; gap: 1.5rem;">
                         <p style="color: var(--text-muted);">Calculando plazos judiciales...</p>
                    </div>
                </section>

                <!-- Side Widgets -->
                <aside style="display: flex; flex-direction: column; gap: 2rem;">
                    <!-- Next Hearing Widget -->
                    <div class="glass-container" style="padding: 2rem; border-left: 4px solid #f59e0b; background: linear-gradient(145deg, rgba(245, 158, 11, 0.1), rgba(0,0,0,0));">
                        <h3 style="font-size: 1rem; color: #f59e0b; margin-bottom: 1rem; text-transform: uppercase; font-weight: 800;">Próxima Audiencia</h3>
                        <div id="next-hearing-widget">
                            <p style="color: var(--text-muted); font-size: 0.9rem;">Buscando en agenda...</p>
                        </div>
                    </div>

                    <!-- Stats -->
                    <div class="glass-container" style="padding: 2rem;">
                        <h3 style="font-size: 0.9rem; color: var(--text-muted); margin-bottom: 1rem; text-transform: uppercase;">Métricas de Plazos</h3>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                            <div style="text-align: center; padding: 1rem; background: rgba(255,255,255,0.03); border-radius: 10px;">
                                <span style="display: block; font-size: 1.5rem; font-weight: 700; color: #ef4444;" id="stat-urgent">0</span>
                                <span style="font-size: 0.6rem; color: var(--text-muted);">URGENTES</span>
                            </div>
                            <div style="text-align: center; padding: 1rem; background: rgba(255,255,255,0.03); border-radius: 10px;">
                                <span style="display: block; font-size: 1.5rem; font-weight: 700; color: #10b981;" id="stat-ok">0</span>
                                <span style="font-size: 0.6rem; color: var(--text-muted);">EN TÉRMINO</span>
                            </div>
                        </div>
                    </div>
                </aside>

            </main>
            ${getLegalWarningHTML()}
        </div>
    `;

  const container = document.querySelector('#agenda-list');
  try {
    const events = await CaseService.getUpcomingDeadlines(state.user.uid);

    // Update Stats
    const urgentCount = events.filter(e => e.isDeadline).length;
    document.querySelector('#stat-urgent').innerText = urgentCount;
    document.querySelector('#stat-ok').innerText = events.length - urgentCount;

    // Update Widget
    const nextHearing = events.find(e => e.title.toLowerCase().includes('audiencia') || e.title.toLowerCase().includes('vista'));
    if (nextHearing) {
      document.querySelector('#next-hearing-widget').innerHTML = `
            <div style="margin-bottom: 0.5rem;">
                <span style="font-size: 2rem; font-weight: 700; line-height: 1;">${nextHearing.dateObj.getDate()}</span>
                <span style="font-size: 0.9rem; text-transform: uppercase;">${nextHearing.dateObj.toLocaleString('es-CR', { month: 'long' })}</span>
            </div>
            <p style="font-weight: 700; margin-bottom: 0.2rem;">${nextHearing.title}</p>
            <p style="font-size: 0.8rem; color: var(--text-muted);">${nextHearing.caseTitle}</p>
         `;
    } else {
      document.querySelector('#next-hearing-widget').innerHTML = `<p style="color: var(--text-muted); font-size: 0.9rem;">No hay audiencias próximas.</p>`;
    }


    if (events.length === 0) {
      container.innerHTML = `<div style="text-align: center; padding: 3rem; color: var(--text-muted);">
            <span style="font-size: 2rem; display: block; margin-bottom: 1rem;">☕</span>
            No tiene vencimientos ni audiencias programadas.
      </div>`;
      return;
    }

    container.innerHTML = events.map(e => {
      // Lógica de Semáforo
      let color = '#10b981'; // Verde (Controlado) por defecto
      let typeLabel = 'CONTROLADO';

      if (e.isDeadline) {
        color = '#ef4444'; // Rojo (Crítico)
        typeLabel = 'PLAZO FATAL';
      } else if (e.title.toLowerCase().includes('audiencia') || e.title.toLowerCase().includes('vista')) {
        color = '#f59e0b'; // Amarillo Fuerte (Alerta)
        typeLabel = 'AUDIENCIA';
      }

      return `
            <div style="display: flex; align-items: flex-start; gap: 20px; padding: 1.5rem; border-radius: 12px; background: rgba(255,255,255,0.02); border: 1px solid ${color}; border-left: 5px solid ${color}; position: relative; overflow: hidden; transition: transform 0.2s;" onmouseover="this.style.transform='translateX(5px)'" onmouseout="this.style.transform='translateX(0)'">
                <div style="position: absolute; top: 0; right: 0; background: ${color}; color: black; font-size: 0.6rem; font-weight: 800; padding: 2px 10px; border-bottom-left-radius: 8px;">
                    ${typeLabel}
                </div>
                <div style="text-align: center; min-width: 80px;">
                    <span style="display: block; font-size: 0.8rem; font-weight: 800; color: ${color}; text-transform: uppercase;">${e.dateObj.toLocaleString('es-CR', { month: 'short' })}</span>
                    <span style="display: block; font-size: 1.8rem; font-weight: 700; line-height: 1; margin: 2px 0;">${e.dateObj.getDate()}</span>
                    <span style="display: block; font-size: 0.7rem; color: var(--text-muted); text-transform: uppercase;">${e.dateObj.toLocaleString('es-CR', { weekday: 'short' })}</span>
                </div>
                <div style="flex: 1;">
                    <span style="font-size: 0.65rem; color: var(--text-muted); font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">${e.caseTitle}</span>
                    <h3 style="font-size: 1.1rem; margin: 4px 0;">${e.title}</h3>
                    <p style="font-size: 0.85rem; color: var(--text-muted);">${e.description ? e.description.substring(0, 100) + '...' : ''}</p>
                </div>
                <button onclick="openCase('${e.caseId}')" style="padding: 0.6rem 1.2rem; border-radius: 8px; border: 1px solid var(--glass-border); background: rgba(255,255,255,0.05); color: white; font-size: 0.8rem; font-weight: 600; cursor: pointer;">Ver Expediente</button>
            </div>
        `;
    }).join('');

  } catch (err) {
    container.innerHTML = `<p style="color: #ef4444;">Error al cargar el calendario.</p>`;
  }
}

async function renderMarketingDashboard() {
  app.innerHTML = `
        <div style="display: grid; grid-template-columns: 280px 1fr; height: 100vh;" class="premium-gradient">
            ${getSidebarHTML('marketing')}
            <main style="padding: 3rem; overflow-y: auto;">
                <header style="margin-bottom: 4rem;" class="fade-in">
                    <h1 style="font-family: var(--font-title); font-size: 3rem; margin-bottom: 0.5rem;" class="gold-text">Marketing Autopilot</h1>
                    <p style="color: var(--text-muted); font-size: 1.2rem; font-weight: 500;">Atracción estratégica de prospectos de alto valor.</p>
                </header>

                <div style="display: grid; grid-template-columns: 1fr 350px; gap: 2rem;">
                    <!-- Columna: Gestión de Leads -->
                    <section>
                        <div class="glass-container" style="padding: 2rem; margin-bottom: 2rem;">
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem;">
                                <h2 style="font-size: 1.2rem; display: flex; align-items: center; gap: 10px;"><span>🎯</span> Prospectos en Evaluación (Filtro de Rentabilidad)</h2>
                                <button onclick="simulateNewLead()" style="background: var(--secondary-color); color: #1a237e; border: none; padding: 0.6rem 1rem; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer;">Simular Formulario Web</button>
                            </div>
                            
                            <div id="leads-list" style="display: flex; flex-direction: column; gap: 1rem;">
                                <!-- Leads Card -->
                                <div style="padding: 1.5rem; border: 1px solid var(--glass-border); border-radius: 15px; background: rgba(255,255,255,0.02); display: flex; justify-content: space-between; align-items: center;">
                                    <div>
                                        <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 0.5rem;">
                                             <h4 style="font-size: 1.1rem; margin: 0;">Juan Pérez (Divorcio Contencioso)</h4>
                                             <span style="background: #10b981; color: white; padding: 2px 8px; border-radius: 20px; font-size: 0.6rem; font-weight: 800;">ALTA RENTABILIDAD</span>
                                        </div>
                                        <p style="font-size: 0.8rem; color: var(--text-muted);">Capacidad Financiera: A+ | Precedente: Ganable (90%) | Vía: Formulario Web</p>
                                    </div>
                                    <div style="display: flex; gap: 8px;">
                                        <button style="padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--secondary-color); background: transparent; color: var(--secondary-color); font-weight: 700; cursor: pointer; font-size: 0.7rem;">FILTRAR DETALLE</button>
                                        <button style="padding: 0.5rem 1rem; border-radius: 8px; border: none; background: #3b82f6; color: white; font-weight: 700; cursor: pointer; font-size: 0.7rem;">ACEPTAR CASO</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Sección de Testimonios y Autoridad -->
                        <div class="glass-container" style="padding: 2rem;">
                            <h2 style="font-size: 1.2rem; margin-bottom: 1.5rem;">🌟 Prueba Social y Autoridad</h2>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                                <div style="background: rgba(255,255,255,0.03); padding: 1.5rem; border-radius: 12px;">
                                    <h5 style="color: var(--secondary-color); margin-bottom: 0.5rem;">Efectividad Total</h5>
                                    <p style="font-size: 1.5rem; font-weight: 700;">87% Casos Ganados</p>
                                    <p style="font-size: 0.7rem; color: var(--text-muted);">En el último semestre (Basado en historial)</p>
                                </div>
                                <div style="background: rgba(255,255,255,0.03); padding: 1.5rem; border-radius: 12px;">
                                    <h5 style="color: #60a5fa; margin-bottom: 0.5rem;">Recaudación Honorarios</h5>
                                    <p style="font-size: 1.5rem; font-weight: 700;">$42k+ USD</p>
                                    <p style="font-size: 0.7rem; color: var(--text-muted);">Eficiencia en cobro automatizado</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- Columna: Generador de Redes -->
                    <aside>
                        <div class="glass-container" style="padding: 2rem; position: sticky; top: 0;">
                            <h3 style="font-size: 1.1rem; margin-bottom: 1.2rem; color: #f87171;">🎞️ Generador de Contenido</h3>
                            <p style="font-size: 0.75rem; color: var(--text-muted); margin-bottom: 1.5rem;">Crea material diario para redes basándote en la sabiduría de tus éxitos registrados.</p>
                            
                            <div style="display: flex; flex-direction: column; gap: 1rem;">
                                <button onclick="generatePost('LinkedIn')" style="width: 100%; padding: 0.8rem; border-radius: 10px; background: #0077b5; color: white; border: none; font-weight: 700; cursor: pointer; display: flex; items-center; gap: 10px; font-size: 0.8rem; justify-content: center;">
                                    Post para LinkedIn 💼
                                </button>
                                <button onclick="generatePost('X')" style="width: 100%; padding: 0.8rem; border-radius: 10px; background: #000; color: white; border: 1px solid var(--glass-border); font-weight: 700; cursor: pointer; font-size: 0.8rem;">
                                    Hilo para X (Twitter) 𝕏
                                </button>
                                <button onclick="generatePost('YouTube')" style="width: 100%; padding: 0.8rem; border-radius: 10px; background: #ff0000; color: white; border: none; font-weight: 700; cursor: pointer; font-size: 0.8rem;">
                                    Guion para YouTube/Short 🎥
                                </button>
                            </div>

                            <div id="content-output" style="margin-top: 2rem; padding: 1rem; background: rgba(0,0,0,0.3); border-radius: 10px; display: none;">
                                <label style="font-size: 0.65rem; color: var(--secondary-color); font-weight: 800;">CONTENIDO GENERADO ↓</label>
                                <p id="generated-text" style="font-size: 0.8rem; color: white; margin-top: 10px; line-height: 1.5;"></p>
                                <button onclick="copyContent()" style="width: 100%; padding: 0.5rem; background: transparent; border: 1px solid var(--glass-border); color: white; border-radius: 5px; cursor: pointer; font-size: 0.7rem; margin-top: 10px;">Copiar al Portapapeles</button>
                            </div>
                        </div>
                    </aside>
                </div>
            </main>
        </div>
    `;
}

window.generatePost = (platform) => {
  const output = document.querySelector('#content-output');
  const text = document.querySelector('#generated-text');
  output.style.display = 'block';

  // Simulación de generación basada en la Bóveda Maestra
  const topics = [
    "¿Sabías que el 80% de los procesos de familia se pueden resolver antes de juicio si tienes la estrategia de 'Fisura de Negociación'? En Control Legal Total lo hacemos posible.",
    "Justicia rápida no es un mito. Hoy cerramos un caso civil en tiempo récord gracias a nuestra gestión de Folio Digital. #LegalTech #AbogadosExpertos",
    "El secreto de ganar un juicio no está en la ley, está en la prueba perfectamente vinculada al hecho. En mi bufete, nuestra IA no deja vacíos. #VictoriaJudicial"
  ];

  text.innerText = `[${platform}]: ${topics[Math.floor(Math.random() * topics.length)]}`;
}

window.simulateNewLead = () => {
  alert('Un nuevo prospecto ha completado el Formulario de Admisión Web. El sistema está evaluando su scoring...');
  setTimeout(() => {
    alert('REPORTE DE CALIFICACIÓN:\n- Victoria Probable: 95%\n- Capacidad Pago: Alta (Pre-aprobado)\n- ROI Estimado: 4.5x\n\nEl lead ha sido marcado como "ALTA RENTABILIDAD".');
  }, 1500);
}

// INICIALIZACIÓN
AuthService.subscribeToAuthChanges(async (user) => {
  if (user) {
    state.fbUser = user;
    // Restaurar token si existe
    state.googleToken = AuthService.getStoredGoogleToken();
    try {
      // Sincronizar y obtener datos extendidos (Rol, etc)
      state.user = await UserService.syncUserProfile(user);

      // Inicializar Módulo Admin (si aplica)
      AdminUI.init(state.user);

      state.currentView = 'dashboard';
    } catch (err) {
      console.error("Error al iniciar perfil profesional:", err);
      // fallback si falla firestore pero auth está bien
      state.user = { ...user, role: 'abogado_titular' };
      state.currentView = 'dashboard';
    }
  } else {
    state.fbUser = null;
    state.user = null;
    state.googleToken = null; // Limpiar token al cerrar
    state.currentView = 'login';
  }
  renderApp();
});

// Expose functions to window for onclick handlers
window.renderApp = renderApp;
window.state = state;
window.authService = AuthService;
window.showNewCaseModal = showNewCaseModal;
window.showEditActionModal = showEditActionModal;
window.forceSystemUpdate = forceSystemUpdate;

// --- BULK ACTIONS FOR WRITINGS ---
function initBulkActionsToolbarWritings() {
  if (document.getElementById('bulk-actions-toolbar-writings')) {
    return;
  }

  const toolbar = document.createElement('div');
  toolbar.id = 'bulk-actions-toolbar-writings';
  toolbar.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%) translateY(200%);
    background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
    border: 2px solid #c5a059;
    border-radius: 50px;
    padding: 1rem 2.5rem;
    display: flex;
    align-items: center;
    gap: 20px;
    box-shadow: 0 20px 60px rgba(197, 160, 89, 0.4), 0 0 0 1px rgba(255,255,255,0.1) inset;
    z-index: 9999;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    backdrop-filter: blur(20px);
  `;

  toolbar.innerHTML = `
    <span id="selected-count-writings" style="color: #c5a059; font-weight: 800; font-size: 1rem; border-right: 2px solid #c5a059; padding-right: 20px; margin-right: 10px; text-transform: uppercase; letter-spacing: 1px;">0 SELECCIONADOS</span>
    <button onclick="executeBulkActionWritings('whatsapp')" title="Enviar por WhatsApp" style="background: rgba(37, 211, 102, 0.15); border: 1px solid rgba(37, 211, 102, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">📱</button>
    <button onclick="executeBulkActionWritings('telegram')" title="Enviar por Telegram" style="background: rgba(0, 136, 204, 0.15); border: 1px solid rgba(0, 136, 204, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">🛩️</button>
    <button onclick="executeBulkActionWritings('email')" title="Enviar por Correo" style="background: rgba(59, 130, 246, 0.15); border: 1px solid rgba(59, 130, 246, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">📧</button>
    <div style="width: 2px; height: 30px; background: #c5a059; opacity: 0.3; border-radius: 2px;"></div>
    <button onclick="executeBulkActionWritings('delete')" title="Eliminar Seleccionados" style="background: rgba(239, 68, 68, 0.15); border: 1px solid rgba(239, 68, 68, 0.4); border-radius: 8px; padding: 0.5rem; font-size: 1.3rem; cursor: pointer; color: #ef4444; transition: all 0.2s;" onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'">🗑️</button>
  `;

  document.body.appendChild(toolbar);
}

window.toggleBulkToolbarWritings = () => {
  const checkboxes = document.querySelectorAll('.writing-checkbox:checked');
  const toolbar = document.getElementById('bulk-actions-toolbar-writings');
  const countSpan = document.getElementById('selected-count-writings');

  if (!toolbar) return;

  if (checkboxes.length > 0) {
    toolbar.style.transform = 'translateX(-50%) translateY(0)';
    if (countSpan) countSpan.innerText = `${checkboxes.length} SELECCIONADO${checkboxes.length > 1 ? 'S' : ''}`;
  } else {
    toolbar.style.transform = 'translateX(-50%) translateY(200%)';
  }
};

window.executeBulkActionWritings = async (actionType) => {
  const checkboxes = document.querySelectorAll('.writing-checkbox:checked');
  const selectedIds = Array.from(checkboxes).map(cb => cb.value);

  if (selectedIds.length === 0) {
    alert('No hay escritos seleccionados');
    return;
  }

  if (actionType === 'whatsapp') {
    try {
      const allWritings = await CaseService.getWritings(state.currentCaseId);
      const selectedDocs = allWritings.filter(w => selectedIds.includes(w.id));

      let text = `📝 *Escritos del Caso:* ${state.currentCase.title}\n`;
      text += `🆔 *ID Judicial:* ${state.currentCase.judicialId || 'N/A'}\n\n`;

      selectedDocs.forEach((doc, index) => {
        text += `${index + 1}. *${doc.title}* (${doc.type || 'ESCRITO'})\n`;
        text += `   📊 Estado: ${doc.status || 'BORRADOR'}\n`;
        if (doc.gDocUrl) {
          text += `   🔗 ${doc.gDocUrl}\n`;
        }
        text += `\n`;
      });

      text += `\n_Enviado desde Control Legal Total_`;

      window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
    } catch (e) {
      alert('Error al preparar WhatsApp: ' + e.message);
    }
  }

  if (actionType === 'telegram') {
    try {
      const allWritings = await CaseService.getWritings(state.currentCaseId);
      const selectedDocs = allWritings.filter(w => selectedIds.includes(w.id));

      let text = `📝 Escritos del Caso: ${state.currentCase.title}\n`;
      text += `🆔 ID Judicial: ${state.currentCase.judicialId || 'N/A'}\n\n`;

      selectedDocs.forEach((doc, index) => {
        text += `${index + 1}. ${doc.title} (${doc.type || 'ESCRITO'})\n`;
        text += `   📊 Estado: ${doc.status || 'BORRADOR'}\n`;
        if (doc.gDocUrl) {
          text += `   🔗 ${doc.gDocUrl}\n`;
        }
        text += `\n`;
      });

      text += `\nEnviado desde Control Legal Total`;

      window.open(`https://t.me/share/url?url=${encodeURIComponent('https://lexocontrol.web.app')}&text=${encodeURIComponent(text)}`, '_blank');
    } catch (e) {
      alert('Error al preparar Telegram: ' + e.message);
    }
  }

  if (actionType === 'email') {
    try {
      const allWritings = await CaseService.getWritings(state.currentCaseId);
      const selectedDocs = allWritings.filter(w => selectedIds.includes(w.id));

      const subject = `Escritos Caso: ${state.currentCase.title}`;
      let body = `Escritos del Caso: ${state.currentCase.title}\n`;
      body += `ID Judicial: ${state.currentCase.judicialId || 'N/A'}\n\n`;
      body += `Escritos:\n\n`;

      selectedDocs.forEach((doc, index) => {
        body += `${index + 1}. ${doc.title} (${doc.type || 'ESCRITO'})\n`;
        body += `   Estado: ${doc.status || 'BORRADOR'}\n`;
        if (doc.gDocUrl) {
          body += `   Link: ${doc.gDocUrl}\n`;
        }
        body += `\n`;
      });

      body += `\nEnviado desde Control Legal Total`;

      window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
    } catch (e) {
      alert('Error al preparar Email: ' + e.message);
    }
  }

  if (actionType === 'delete') {
    if (!confirm(`¿Eliminar ${selectedIds.length} escrito(s) seleccionado(s)?`)) return;

    try {
      for (const id of selectedIds) {
        await CaseService.deleteWriting(state.currentCaseId, id);
      }

      // Deselect and hide toolbar
      checkboxes.forEach(cb => cb.checked = false);
      toggleBulkToolbarWritings();

      loadDraftingView(state.currentCaseId);
      alert('Escritos eliminados correctamente');
    } catch (e) {
      alert('Error al eliminar: ' + e.message);
    }
  }
};

// ===== FUNCIONES DE TIMELINE =====

let timelineState = {
  events: [],
  zoom: 1,
  startDate: null,
  endDate: null
};

async function loadTimelineView(caseId) {
  try {
    // Cargar eventos
    const events = await TimelineService.getEvents(caseId);
    timelineState.events = events;

    if (events.length === 0) {
      // Si no hay eventos, ofrecer sincronizar
      const container = document.getElementById('timeline-events');
      if (container) {
        container.innerHTML = `
            <div style="text-align: center; padding: 3rem;">
              <p style="color: var(--text-muted); margin-bottom: 1rem;">
                No hay eventos en la línea de tiempo aún.
              </p>
              <button onclick="syncTimelineFromActions('${caseId}')" class="btn-gold">
                🔄 CREAR TIMELINE DESDE DOCUMENTOS
              </button>
            </div>
          `;
      }
      return;
    }

    // Calcular rango de fechas (con validación)
    if (!events.some(e => e.date && e.date.seconds)) {
      console.warn("Eventos sin fecha válida encontrados");
    }

    // Filtrar eventos con fechas válidas para el cálculo del rango
    const validEvents = events.filter(e => e.date && e.date.seconds);

    if (validEvents.length === 0) {
      timelineState.startDate = new Date();
      timelineState.endDate = new Date();
      timelineState.endDate.setFullYear(timelineState.endDate.getFullYear() + 1);
    } else {
      const dates = validEvents.map(e => new Date(e.date.seconds * 1000));
      timelineState.startDate = new Date(Math.min(...dates));
      timelineState.endDate = new Date(Math.max(...dates));
    }

    // Agregar margen al futuro (2 años) por defecto
    const futureDate = new Date();
    futureDate.setFullYear(futureDate.getFullYear() + 2);
    if (futureDate > timelineState.endDate) {
      timelineState.endDate = futureDate;
    }

    // Agregar margen al pasado (1 mes) para que no quede pegado al borde
    const pastMargin = new Date(timelineState.startDate);
    pastMargin.setMonth(pastMargin.getMonth() - 1);
    timelineState.startDate = pastMargin;

    // ⚠️ ANÁLISIS DE RIESGO CRÍTICO - ESTO PUEDE SALVAR FAMILIAS DE PERDER SUS BIENES
    const riskAnalysis = generateRiskAnalysis(events);
    const alertContainer = document.getElementById('timeline-risk-alerts');

    if (alertContainer && (riskAnalysis.plazosVencidos.length > 0 || riskAnalysis.plazosCriticos.length > 0)) {
      const nivelColor = {
        'ALTO': '#dc2626',
        'MEDIO': '#f97316',
        'BAJO': '#10b981'
      };

      alertContainer.innerHTML = `
        <div style="background: linear-gradient(135deg, ${nivelColor[riskAnalysis.nivelRiesgo]}22 0%, ${nivelColor[riskAnalysis.nivelRiesgo]}11 100%); 
                    border: 2px solid ${nivelColor[riskAnalysis.nivelRiesgo]}; 
                    border-radius: 12px; 
                    padding: 1.5rem; 
                    margin-bottom: 1.5rem;
                    animation: pulse-alert 2s ease-in-out infinite;">
          <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem;">
            <span style="font-size: 2rem;">${riskAnalysis.nivelRiesgo === 'ALTO' ? '🚨' : '⚠️'}</span>
            <div>
              <h3 style="color: ${nivelColor[riskAnalysis.nivelRiesgo]}; margin: 0; font-size: 1.2rem; font-weight: 700;">
                ALERTA DE RIESGO ${riskAnalysis.nivelRiesgo}
              </h3>
              <p style="margin: 0.25rem 0 0 0; font-size: 0.9rem; color: var(--text-muted);">
                ${riskAnalysis.plazosVencidos.length > 0 ? 'PLAZOS VENCIDOS DETECTADOS' : 'Plazos críticos próximos a vencer'}
              </p>
            </div>
          </div>
          <div style="display: flex; flex-direction: column; gap: 0.5rem;">
            ${riskAnalysis.alertas.map(alerta => `
              <div style="padding: 0.75rem; background: rgba(0,0,0,0.3); border-radius: 8px; font-size: 0.95rem;">
                ${alerta}
              </div>
            `).join('')}
          </div>
          ${riskAnalysis.plazosVencidos.length > 0 ? `
            <div style="margin-top: 1rem; padding: 1rem; background: rgba(220, 38, 38, 0.2); border-radius: 8px;">
              <strong style="color: #dc2626;">⚡ ACCIÓN INMEDIATA REQUERIDA:</strong>
              <p style="margin: 0.5rem 0 0 0; font-size: 0.9rem;">
                Estos plazos vencidos pueden comprometer seriamente el caso. Revise con su equipo legal AHORA.
              </p>
            </div>
          ` : ''}
        </div>
      `;

      // Agregar animación de pulso para alertas críticas
      if (!document.getElementById('timeline-alert-animations')) {
        const style = document.createElement('style');
        style.id = 'timeline-alert-animations';
        style.textContent = `
          @keyframes pulse-alert {
            0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 ${nivelColor[riskAnalysis.nivelRiesgo]}44; }
            50% { transform: scale(1.01); box-shadow: 0 0 20px 5px ${nivelColor[riskAnalysis.nivelRiesgo]}22; }
          }
        `;
        document.head.appendChild(style);
      }
    } else if (alertContainer) {
      alertContainer.innerHTML = `
        <div style="background: linear-gradient(135deg, #10b98122 0%, #10b98111 100%); 
                    border: 2px solid #10b981; 
                    border-radius: 12px; 
                    padding: 1rem 1.5rem; 
                    margin-bottom: 1.5rem;
                    display: flex;
                    align-items: center;
                    gap: 1rem;">
          <span style="font-size: 1.5rem;">✅</span>
          <div>
            <strong style="color: #10b981;">Sin plazos críticos pendientes</strong>
            <p style="margin: 0.25rem 0 0 0; font-size: 0.85rem; color: var(--text-muted);">
              Todos los plazos bajo control
            </p>
          </div>
        </div>
      `;
    }

    // Renderizar eventos
    renderTimelineEvents();

    // Posicionar marcador de presente
    positionPresentMarker();

  } catch (err) {
    console.error('Error cargando timeline:', err);
    const container = document.getElementById('timeline-events');
    if (container) {
      container.innerHTML = `
        <p style="color: #ef4444;">Error cargando timeline: ${err.message}</p>
      `;
    }
  }
}

function renderTimelineEvents() {
  const container = document.getElementById('timeline-events');
  if (!container) return;

  container.innerHTML = '';

  const totalDuration = timelineState.endDate - timelineState.startDate;
  if (totalDuration <= 0) return; // Evitar división por cero

  timelineState.events.forEach(event => {
    if (!event.date || !event.date.seconds) return;

    const eventDate = new Date(event.date.seconds * 1000);
    const position = ((eventDate - timelineState.startDate) / totalDuration) * 100;

    // Limitar posición entre 0 y 100 para evitar desbordes visuales extremos
    if (position < -5 || position > 105) return;

    const eventEl = document.createElement('div');
    eventEl.className = `timeline-event ${event.isFuture ? 'future' : ''}`;
    eventEl.style.setProperty('--event-position', `${position}%`);
    eventEl.style.setProperty('--event-color', event.color || '#60a5fa');

    eventEl.innerHTML = `
      <div class="event-marker">
        <span class="event-icon">${getEventIcon(event.type)}</span>
      </div>
      <div class="event-label">
        <strong title="${event.title}">${event.title.substring(0, 30)}${event.title.length > 30 ? '...' : ''}</strong>
        <span class="event-date">${eventDate.toLocaleDateString()}</span>
      </div>
      <div class="event-connector"></div>
    `;

    eventEl.onclick = () => showEventDetails(event);

    container.appendChild(eventEl);
  });
}

function getEventIcon(type) {
  const icons = {
    'hecho_generador': '🏠',
    'demanda': '📄',
    'sentencia': '⚖️',
    'notificacion': '📬',
    'prueba': '📎',
    'audiencia': '🎙️',
    'plazo': '⏰',
    'document': '📄'
  };
  return icons[type] || '📋';
}

function positionPresentMarker() {
  const now = new Date();
  if (!timelineState.startDate || !timelineState.endDate) return;

  const totalDuration = timelineState.endDate - timelineState.startDate;
  if (totalDuration <= 0) return;

  const position = ((now - timelineState.startDate) / totalDuration) * 100;

  const marker = document.getElementById('present-marker');
  if (!marker) return;

  // Ocultar si está muy fuera de rango
  if (position < -10 || position > 110) {
    marker.style.display = 'none';
  } else {
    marker.style.display = 'block';
    marker.style.setProperty('--present-position', `${position}%`);
  }

  // Actualizar progreso del track
  const track = document.getElementById('timeline-track');
  if (track) {
    let progress = position;
    if (progress < 0) progress = 0;
    if (progress > 100) progress = 100;
    track.style.setProperty('--past-progress', `${progress}%`);
  }
}

function showEventDetails(event) {
  const panel = document.getElementById('event-details-panel');
  if (!panel) return;

  const eventDate = new Date(event.date.seconds * 1000);

  panel.style.setProperty('--event-color', event.color || '#c5a059');
  panel.className = 'event-details-panel';

  const docs = Array.isArray(event.documents) ? event.documents : [];

  panel.innerHTML = `
    <div class="event-details-header">
      <div>
        <h3 class="event-details-title">${getEventIcon(event.type)} ${event.title}</h3>
        <p class="event-details-date">${eventDate.toLocaleDateString('es-CR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })}</p>
      </div>
      <button class="event-details-close" onclick="closeEventDetails()">×</button>
    </div>
    
    <div class="event-details-body">
      ${event.description ? `
        <div class="event-details-section">
          <p style="color: var(--text-muted); font-size: 0.85rem;">${event.description}</p>
        </div>
      ` : ''}
      
      ${docs.length > 0 ? `
        <div class="event-details-section">
          <div class="event-details-section-title">📋 Documentos (${docs.length})</div>
          ${docs.map(doc => `
            <div class="event-document-item" onclick="window.open('${doc.link}', '_blank')">
              <span>📄</span>
              <span>${doc.name}</span>
            </div>
          `).join('')}
        </div>
      ` : ''}
      
      <div style="display: flex; gap: 10px; margin-top: 1rem;">
        <button onclick="editEvent('${event.id}')" class="btn-outline" style="flex: 1;">
          ✏️ Editar
        </button>
        <button onclick="deleteTimelineEvent('${event.id}')" class="btn-outline" style="flex: 1; color: #ef4444; border-color: rgba(239, 68, 68, 0.3);">
          🗑️ Eliminar
        </button>
      </div>
    </div>
  `;

  panel.style.display = 'block';
}

function closeEventDetails() {
  const panel = document.getElementById('event-details-panel');
  if (panel) {
    panel.style.display = 'none';
  }
}

// ===== MODAL DE TRIAJE DOCUMENTAL =====
function showTriageModal(triageResult, caseId, onConfirm) {
  const modal = document.createElement('div');
  modal.className = 'triage-modal';

  const { stats, byLevel, duplicates } = triageResult;

  modal.innerHTML = `
    <div class="triage-container">
      <!-- Header -->
      <div class="triage-header">
        <h2>🤖 Análisis Inteligente de Documentos</h2>
        <p style="color: var(--text-muted); margin: 0.5rem 0 0 0;">Sistema de triaje automático con 3 niveles</p>
        
        <!-- Estadísticas -->
        <div class="triage-stats">
          <div class="triage-stat-card level-1">
            <div class="label">🟢 Clasificación Automática</div>
            <div class="number">${stats.autoClassify}</div>
          </div>
          <div class="triage-stat-card level-2">
            <div class="label">🟡 Requiere IA</div>
            <div class="number">${stats.needsAI}</div>
          </div>
          <div class="triage-stat-card level-3">
            <div class="label">🔴 Revisión Humana</div>
            <div class="number">${stats.needsHuman}</div>
          </div>
          <div class="triage-stat-card duplicates">
            <div class="label">🗑️ Duplicados</div>
            <div class="number">${stats.duplicates + stats.possibleDuplicates}</div>
          </div>
        </div>
      </div>
      
      <!-- Body con lista de documentos -->
      <div class="triage-body">
        ${stats.duplicates > 0 ? `
          <div class="triage-section">
            <div class="triage-section-header duplicates">
              <h3>🗑️ Duplicados Exactos - Marcar para Eliminar</h3>
              <span class="count">${stats.duplicates}</span>
            </div>
            <div class="triage-document-list">
              ${byLevel.duplicates.map(doc => `
                <div class="triage-document-item duplicate">
                  <div class="triage-doc-icon">📄</div>
                  <div class="triage-doc-info">
                    <p class="triage-doc-name">${doc.name || 'Sin nombre'}</p>
                    <p class="triage-doc-reason">Duplicado de: ${triageResult.all[doc.duplicateOf]?.name || 'documento anterior'}</p>
                  </div>
                  <span class="triage-doc-badge delete">ELIMINAR</span>
                </div>
              `).join('')}
            </div>
          </div>
        ` : ''}
        
        ${stats.autoClassify > 0 ? `
          <div class="triage-section">
            <div class="triage-section-header level-1">
              <h3>🟢 Nivel 1 - Procesamiento Automático</h3>
              <span class="count">${stats.autoClassify}</span>
            </div>
            <div class="triage-document-list">
              ${byLevel.level1_auto.slice(0, 5).map(doc => `
                <div class="triage-document-item">
                  <div class="triage-doc-icon">${getTriageIcon(1)}</div>
                  <div class="triage-doc-info">
                    <p class="triage-doc-name">${doc.name || 'Sin nombre'}</p>
                    <p class="triage-doc-reason">${doc.triageReason}</p>
                  </div>
                  <span class="triage-doc-badge auto">AUTO</span>
                </div>
              `).join('')}
              ${stats.autoClassify > 5 ? `<p style="text-align: center; color: var(--text-muted); font-size: 0.85rem; margin-top: 0.5rem;">+ ${stats.autoClassify - 5} documentos más...</p>` : ''}
            </div>
          </div>
        ` : ''}
        
        ${stats.needsAI > 0 ? `
          <div class="triage-section">
            <div class="triage-section-header level-2">
              <h3>🟡 Nivel 2 - Análisis con IA (Document AI)</h3>
              <span class="count">${stats.needsAI}</span>
            </div>
            <div class="triage-document-list">
              ${byLevel.level2_ai.slice(0, 3).map(doc => `
                <div class="triage-document-item">
                  <div class="triage-doc-icon">${getTriageIcon(2)}</div>
                  <div class="triage-doc-info">
                    <p class="triage-doc-name">${doc.name || 'Sin nombre'}</p>
                    <p class="triage-doc-reason">${doc.triageReason}</p>
                  </div>
                  <span class="triage-doc-badge ai">IA</span>
                </div>
              `).join('')}
              ${stats.needsAI > 3 ? `<p style="text-align: center; color: var(--text-muted); font-size: 0.85rem; margin-top: 0.5rem;">+ ${stats.needsAI - 3} documentos más...</p>` : ''}
            </div>
          </div>
        ` : ''}
        
        ${stats.needsHuman > 0 ? `
          <div class="triage-section">
            <div class="triage-section-header level-3">
              <h3>🔴 Nivel 3 - Revisión Humana Requerida</h3>
              <span class="count">${stats.needsHuman}</span>
            </div>
            <div class="triage-document-list">
              ${byLevel.level3_human.slice(0, 3).map(doc => `
                <div class="triage-document-item">
                  <div class="triage-doc-icon">${getTriageIcon(3)}</div>
                  <div class="triage-doc-info">
                    <p class="triage-doc-name">${doc.name || 'Sin nombre'}</p>
                    <p class="triage-doc-reason">${doc.triageReason}</p>
                  </div>
                  <span class="triage-doc-badge manual">MANUAL</span>
                </div>
              `).join('')}
              ${stats.needsHuman > 3 ? `<p style="text-align: center; color: var(--text-muted); font-size: 0.85rem; margin-top: 0.5rem;">+ ${stats.needsHuman - 3} documentos más...</p>` : ''}
            </div>
          </div>
        ` : ''}
      </div>
      
      <!-- Footer -->
      <div class="triage-footer">
        <button class="triage-btn-cancel" onclick="this.closest('.triage-modal').remove()">
          Cancelar
        </button>
        <button class="triage-btn-process" id="btn-confirm-triage">
          Procesar ${stats.autoClassify + stats.needsAI} Documentos
          ${stats.needsHuman > 0 ? `<br><small style="font-size: 0.75rem; opacity: 0.8;">(${stats.needsHuman} requieren revisión manual)</small>` : ''}
        </button>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  // Event listener para confirmar
  document.getElementById('btn-confirm-triage').addEventListener('click', () => {
    modal.remove();
    onConfirm(triageResult);
  });

  // Click fuera del modal para cerrar
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.remove();
    }
  });
}

async function syncTimelineFromActions(caseId) {
  try {
    // Cargar acciones (documentos) del caso
    const actions = await CaseService.getActions(caseId);

    if (!actions || actions.length === 0) {
      alert('No hay documentos para analizar en este caso.');
      return;
    }

    // ANÁLISIS INTELIGENTE: Convertir acciones a formato compatible
    const driveFiles = actions.map(action => ({
      id: action.id,
      name: action.driveFileName || action.title || 'Sin nombre',
      driveFileName: action.driveFileName,
      driveFileLink: action.driveFileLink,
      createdTime: action.timestamp?.toDate ? action.timestamp.toDate() : new Date(),
      title: action.title,
      description: action.description,
      size: action.size || 0
    }));

    // SISTEMA DE TRIAJE CON DETECCIÓN DE DUPLICADOS
    const triageResult = processBatchWithTriage(driveFiles);

    // Mostrar modal visual de triaje
    showTriageModal(triageResult, caseId, async (result) => {
      // Callback cuando usuario confirma
      const { byLevel } = result;

      // Procesar solo documentos de nivel 1 y 2 (no duplicados, no nivel 3)
      const documentsToProcess = [
        ...byLevel.level1_auto,
        ...byLevel.level2_ai  // Por ahora procesamos como nivel 1, después activamos Document AI
      ];

      if (documentsToProcess.length === 0) {
        alert('No hay documentos para procesar automáticamente.');
        return;
      }

      // Mostrar progress
      let processed = 0;
      const total = documentsToProcess.length;

      for (const doc of documentsToProcess) {
        try {
          // Analizar documento con IA o método básico según nivel de triaje
          let analyzed;

          if (doc.triageLevel === 2) {
            // NIVEL 2: Usar Gemini 2.0 Flash Lite para análisis profundo
            try {
              const { analyzeScannedImageWithGemini } = await import('./geminiAnalyzer.js');
              const analysis = await analyzeScannedImageWithGemini(
                doc.driveFileLink,
                doc.name,
                'AIzaSyB1ZvBFAOlwgQ-d3B8do5-m18oIQ4AekAw',
                state.googleToken // CRITICAL: Pass OAuth Token for Drive Access
              );

              if (analysis.success && analysis.analysis) {
                const gemini = analysis.analysis;
                analyzed = {
                  filename: doc.name,
                  documentType: gemini.tipo_documento || 'document',
                  date: new Date(gemini.fecha_documento || doc.createdTime),
                  confidence: gemini.fecha_confianza || 50,
                  needsReview: gemini.requiere_atencion || false,
                  dateSource: 'gemini-ai',
                  geminiAnalysis: gemini,
                  summary: gemini.resumen || '',
                  parties: gemini.partes || [],
                  figures: gemini.cifras_importantes || [],
                  criticalDates: gemini.fechas_criticas || []
                };
                console.log('✅ Gemini 2.0 analysis:', analyzed);
              } else {
                // Fallback a análisis básico
                analyzed = analyzeDocument(doc);
                analyzed.dateSource = 'basic-fallback';
              }
            } catch (error) {
              console.error('⚠️ Gemini error, using basic analysis:', error);
              analyzed = analyzeDocument(doc);
              analyzed.dateSource = 'basic-fallback';
            }
          } else {
            // NIVEL 1: Análisis básico (documentos simples)
            analyzed = analyzeDocument(doc);
          }

          // Construir descripción rica con análisis de Gemini
          let description = `${doc.triageReason}\n\nTipo: ${analyzed.documentType}\nConfianza: ${analyzed.confidence}%\n`;

          // Agregar fuente del análisis
          if (analyzed.dateSource === 'gemini-ai') {
            description += `🤖 Analizado con Gemini 1.5 Pro\n`;
          } else if (analyzed.dateSource === 'filename') {
            description += `Fuente: nombre de archivo\n`;
          } else {
            description += `Fuente: fecha de upload\n`;
          }

          // Si hay análisis de Gemini, agregar metadata rica
          if (analyzed.geminiAnalysis) {
            const g = analyzed.geminiAnalysis;

            if (g.resumen) {
              description += `\n📝 Resumen:\n${g.resumen}\n`;
            }

            if (g.partes && g.partes.length > 0) {
              description += `\n👥 Partes:\n${g.partes.map(p => `• ${p}`).join('\n')}\n`;
            }

            if (g.cifras_importantes && g.cifras_importantes.length > 0) {
              description += `\n💰 Cifras Importantes:\n${g.cifras_importantes.map(c => `• ${c}`).join('\n')}\n`;
            }

            if (g.fechas_criticas && g.fechas_criticas.length > 0) {
              description += `\n⏰ Fechas Críticas:\n${g.fechas_criticas.map(f => `• ${f}`).join('\n')}\n`;
            }

            if (g.observaciones) {
              description += `\n📌 Observaciones:\n${g.observaciones}\n`;
            }
          }

          await TimelineService.createEvent(caseId, {
            title: analyzed.filename,
            type: getTimelineTypeFromDocType(analyzed.documentType),
            date: analyzed.date,
            description: description,
            color: getColorFromDocType(analyzed.documentType),
            isFuture: analyzed.date > new Date(),
            confidence: analyzed.confidence,
            needsReview: analyzed.needsReview || doc.triageLevel >= 2,
            autoGenerated: true,
            triageLevel: doc.triageLevel,
            sourceDocument: {
              id: doc.id,
              link: doc.driveFileLink,
              filename: doc.name
            }
          });
          processed++;
        } catch (err) {
          console.error('Error creando evento:', err);
        }
      }

      // Mensaje final con estadísticas
      const message = `
✅ Procesamiento Completado

📊 Resultados:
• Eventos creados: ${processed}/${total}
${byLevel.level3_human.length > 0 ? `\n🔴 Documentos que necesitan revisión manual: ${byLevel.level3_human.length}` : ''}
${byLevel.duplicates.length > 0 ? `\n🗑️ Duplicados detectados: ${byLevel.duplicates.length}` : ''}
${byLevel.possibleDuplicates.length > 0 ? `\n⚠️ Posibles duplicados: ${byLevel.possibleDuplicates.length}` : ''}
      `.trim();

      alert(message);

      // Recargar timeline
      loadTimelineView(caseId);
    });

  } catch (err) {
    console.error('Error en sincronización:', err);
    alert('Error sincronizando: ' + err.message);
  }
}

function zoomTimeline(direction) {
  console.log("Zoom " + direction);
  renderTimelineEvents();
}

function showNewEventModal(caseId) {
  const modal = document.createElement('div');
  modal.className = 'modal fade-in';
  modal.style.display = 'flex';
  modal.innerHTML = `
    <div class="glass-container" style="width: 90%; max-width: 600px; padding: 2rem;">
      <h3 style="margin-bottom: 1.5rem; color: var(--primary-gold);">Nuevo Evento en Timeline</h3>
      <form id="new-event-form">
        <div class="form-group">
          <label>Título del Evento</label>
          <input type="text" name="title" required placeholder="Ej: Presentación de Demanda..." style="width: 100%;">
        </div>
        
        <div class="form-group">
          <label>Tipo de Evento</label>
          <select name="type" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(0,0,0,0.3); color: white; border: 1px solid var(--glass-border);">
            <option value="hecho_generador">🏠 Hecho Generador</option>
            <option value="demanda">📄 Demanda</option>
            <option value="sentencia">⚖️ Sentencia</option>
            <option value="notificacion">📬 Notificación</option>
            <option value="prueba">📎 Prueba</option>
            <option value="audiencia">🎙️ Audiencia</option>
            <option value="plazo">⏰ Plazo Fatal</option>
            <option value="document">📋 Documento General</option>
          </select>
        </div>
        
        <div class="form-group">
          <label>Fecha del Evento</label>
          <input type="date" name="date" required style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(0,0,0,0.3); color: white; border: 1px solid var(--glass-border);">
        </div>
        
        <div class="form-group">
          <label>Descripción (Opcional)</label>
          <textarea name="description" rows="3" placeholder="Detalles del evento..." style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(0,0,0,0.3); color: white; border: 1px solid var(--glass-border);"></textarea>
        </div>
        
        <div style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: 2rem;">
          <button type="button" class="btn-outline" onclick="this.closest('.modal').remove()">Cancelar</button>
          <button type="submit" class="btn-gold">Crear Evento</button>
        </div>
      </form>
    </div>
  `;

  document.body.appendChild(modal);

  modal.querySelector('form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('button[type="submit"]');
    btn.disabled = true;
    btn.innerText = "Creando...";

    const formData = new FormData(e.target);

    const typeColors = {
      'hecho_generador': '#c5a059',
      'demanda': '#ef4444',
      'sentencia': '#facc15',
      'notificacion': '#3b82f6',
      'prueba': '#10b981',
      'audiencia': '#f97316',
      'plazo': '#dc2626',
      'document': '#60a5fa'
    };

    try {
      await TimelineService.createEvent(caseId, {
        title: formData.get('title'),
        type: formData.get('type'),
        description: formData.get('description'),
        date: new Date(formData.get('date')),
        color: typeColors[formData.get('type')],
        isFuture: new Date(formData.get('date')) > new Date(),
        isCertain: true,
        documents: []
      });

      modal.remove();
      loadTimelineView(caseId);

    } catch (err) {
      console.error(err);
      alert("Error creando evento: " + err.message);
      btn.disabled = false;
      btn.innerText = "Crear Evento";
    }
  });
}

async function deleteTimelineEvent(eventId) {
  if (!confirm('¿Eliminar este evento de la timeline?')) return;

  try {
    await TimelineService.deleteEvent(state.currentCaseId, eventId);
    closeEventDetails();
    loadTimelineView(state.currentCaseId);
    alert('Evento eliminado correctamente');
  } catch (err) {
    alert('Error eliminando evento: ' + err.message);
  }
}

function editEvent(eventId) {
  const event = timelineState.events.find(e => e.id === eventId);
  if (!event) return;

  const modal = document.createElement('div');
  modal.className = 'modal fade-in';
  modal.style.display = 'flex';

  const eventDate = new Date(event.date.seconds * 1000);
  const dateStr = eventDate.toISOString().split('T')[0];

  modal.innerHTML = `
    <div class="glass-container" style="width: 90%; max-width: 600px; padding: 2rem;">
      <h3 style="margin-bottom: 1.5rem; color: var(--primary-gold);">Editar Evento</h3>
      <form id="edit-event-form">
        <div class="form-group">
          <label>Título del Evento</label>
          <input type="text" name="title" required value="${event.title}" style="width: 100%;">
        </div>
        
        <div class="form-group">
          <label>Tipo de Evento</label>
          <select name="type" id="edit-event-type" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(0,0,0,0.3); color: white; border: 1px solid var(--glass-border);">
            <option value="hecho_generador">Hecho Generador</option>
            <option value="demanda">Demanda</option>
            <option value="sentencia">Sentencia</option>
            <option value="notificacion">Notificación</option>
            <option value="prueba">Prueba</option>
            <option value="audiencia">Audiencia</option>
            <option value="plazo">Plazo Fatal</option>
            <option value="document">Documento General</option>
          </select>
        </div>
        
        <div class="form-group">
          <label>Fecha del Evento</label>
          <input type="date" name="date" required value="${dateStr}" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(0,0,0,0.3); color: white; border: 1px solid var(--glass-border);">
        </div>
        
        <div class="form-group">
          <label>Descripción</label>
          <textarea name="description" rows="3" style="width: 100%; padding: 0.8rem; border-radius: 8px; background: rgba(0,0,0,0.3); color: white; border: 1px solid var(--glass-border);">${event.description || ''}</textarea>
        </div>
        
        <div style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: 2rem;">
          <button type="button" class="btn-outline" onclick="this.closest('.modal').remove()">Cancelar</button>
          <button type="submit" class="btn-gold">Guardar Cambios</button>
        </div>
      </form>
    </div>
  `;

  document.body.appendChild(modal);

  const typeSelect = modal.querySelector('#edit-event-type');
  if (typeSelect) typeSelect.value = event.type;

  modal.querySelector('form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('button[type="submit"]');
    btn.disabled = true;
    btn.innerText = "Guardando...";

    const formData = new FormData(e.target);

    const typeColors = {
      'hecho_generador': '#c5a059',
      'demanda': '#ef4444',
      'sentencia': '#facc15',
      'notificacion': '#3b82f6',
      'prueba': '#10b981',
      'audiencia': '#f97316',
      'plazo': '#dc2626',
      'document': '#60a5fa'
    };

    try {
      await TimelineService.updateEvent(state.currentCaseId, eventId, {
        title: formData.get('title'),
        type: formData.get('type'),
        description: formData.get('description'),
        date: new Date(formData.get('date')),
        color: typeColors[formData.get('type')],
        isFuture: new Date(formData.get('date')) > new Date()
      });

      modal.remove();
      closeEventDetails();
      loadTimelineView(state.currentCaseId);
      alert("Evento actualizado correctamente");

    } catch (err) {
      console.error(err);
      alert("Error actualizando evento: " + err.message);
      btn.disabled = false;
      btn.innerText = "Guardar Cambios";
    }
  });
}

// Exponer funciones globalmente
window.loadTimelineView = loadTimelineView;
window.syncTimelineFromActions = syncTimelineFromActions;
window.zoomTimeline = zoomTimeline;
window.closeEventDetails = closeEventDetails;
window.showNewEventModal = showNewEventModal;
window.deleteTimelineEvent = deleteTimelineEvent;
window.editEvent = editEvent;

// ===== INICIALIZACIÓN DE LA APP =====
AuthService.subscribeToAuthChanges(async (user) => {
  console.log("Auth State Changed:", user ? user.email : "No User");
  state.user = user;

  if (user) {
    // Inicializar sistema de historial (v3.0 Refactor)
    initHistorialSystem();

    state.googleToken = AuthService.getStoredGoogleToken();
    // Si estaba cargando o en login, ir a dashboard
    if (state.currentView === 'loading' || state.currentView === 'login') {
      state.currentView = 'dashboard';
    }
  } else {
    state.currentView = 'login';
  }

  await renderApp();
});

